(function () {
  "use strict";

  if (window.__SPARC_GARAGE_V1_LOADED__) return;
  window.__SPARC_GARAGE_V1_LOADED__ = true;

  var SERIES_SCOPE = "garage";

  var IDS = {
    finish: "sparc-garage-finish",
    adapter: "sparc-driver-adapter",
    hubSleeve: "sparc-muscle-hub-sleeve",
    careKit: "sparc-shared-care-kit"
  };

  var CORE_REF_KEYS = [
    "finish",
    "adapter"
  ];

  var STITCH_COLORS = {
    "Black":"#151515","Red":"#b62323","White":"#efefef","Silver":"#a4a4a4",
    "Gray":"#6f6f6f","Gold":"#c7a32b","Tan":"#b99a74","Brown":"#765038",
    "Dark Brown":"#402b22","Dark Blue":"#263e6d","Lime Green":"#82c341","Purple":"#673a78"
  };

  var FRIENDLY = {};

  var refs = {}, panel = null, sourceHost = null;
  var accs = {}, tabs = {}, mirrors = {};
  var syncPending = false, syncTimer = null, resizeTimer = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clean(s) { return String(s || "").replace(/\s+/g," ").trim(); }
  function friendly(v) {
    if (!v) return "Not selected";
    var display = FRIENDLY[v] || v;

    /* Hulk can decorate rendered option values with price notation such as
       [ $75.00 ], | $75.00 |, or (+$75.00). Strip that only from our
       customer-facing display; the real source value remains untouched. */
    display = String(display)
      .replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ")
      .replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ")
      .replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return display;
  }

  function normalizeAccessoryValue(value) {
    return friendly(value)
      .replace(/[\u201C\u201D\u2033]/g, '"')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .toLowerCase()
      .trim();
  }

  function valueEquals(value, expected) {
    var left = normalizeAccessoryValue(value);
    var right = normalizeAccessoryValue(expected);

    return left === right;
  }

  function spacerIsSelected(value) {
    var v = normalizeAccessoryValue(value);

    return (
      v === '1"' ||
      v === '1.5"'
    );
  }


  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function resolveGarageRef(key) {
    if (key === "careKit") {
      return resolveAccessoryRef(key);
    }

    var id=IDS[key];
    if (!id) return null;

    /* Normal path. */
    var live=
      document.getElementById(id);

    if (live) return live;

    live=
      document.querySelector(
        "." + id
      );

    if (live) {
      if (!live.id) live.id=id;
      return live;
    }

    /* ----------------------------------------------------------
       GARAGE GRIP FINISH FALLBACK

       Hulk's older radio-button renderer is inconsistent about applying
       custom selector IDs/classes. Do not depend on either one.

       Identify the smallest visible container that contains BOTH Garage
       finish choices:
         Machine Finish
         Satin Black

       Then normalize that exact live option wrapper to sparc-garage-finish.
       ---------------------------------------------------------- */
    if (key === "finish") {
      var matches=[];

      qa("*",document).forEach(function(node){
        if (!node || node===document.body || node===document.documentElement ||
            (panel && (node===panel || panel.contains(node) || node.contains(panel)))) {
          return;
        }

        var rect=node.getBoundingClientRect();

        if (
          rect.width <= 0 ||
          rect.height <= 0 ||
          rect.width > 900 ||
          rect.height > 520
        ) {
          return;
        }

        var text=
          clean(
            node.innerText ||
            node.textContent
          ).toLowerCase();

        if (
          text.indexOf("machine finish") === -1 ||
          text.indexOf("satin black") === -1
        ) {
          return;
        }

        /* Require option-like controls or Hulk option markup so we never
           accidentally choose a larger product/page container. */
        var hasControls=
          qa(
            'input[type="radio"],' +
            'input[type="checkbox"],' +
            'select,' +
            'button,' +
            'label',
            node
          ).length > 0;

        var classText=
          String(node.className || "")
            .toLowerCase();

        var hulkLike=
          classText.indexOf("hulk") !== -1 ||
          classText.indexOf("option") !== -1 ||
          classText.indexOf("sparc-config") !== -1 ||
          hasControls;

        if (!hulkLike) return;

        matches.push({
          node:node,
          area:rect.width * rect.height,
          controlCount:
            qa(
              'input[type="radio"],' +
              'input[type="checkbox"],' +
              'select',
              node
            ).length
        });
      });

      if (matches.length) {
        matches.sort(function(a,b){
          /* Prefer the smallest live wrapper around the two choices. */
          if (a.area !== b.area) {
            return a.area - b.area;
          }

          return a.controlCount - b.controlCount;
        });

        live=matches[0].node;
      }

      if (live) {
        live.id=id;

        if (live.classList) {
          live.classList.add(
            "sparc-config-option",
            "sparc-visual-option",
            "sparc-series-garage"
          );
        }

        console.info(
          "[SPARC GARAGE V1.7] Normalized live Grip Finish wrapper:",
          live
        );

        return live;
      }
    }

    return null;
  }


  function refreshRefs() {
    Object.keys(IDS).forEach(function(key) { refs[key]=resolveGarageRef(key) || null; });
  }

  function allRefsPresent() {
    var missing = [];
    refreshRefs();

    CORE_REF_KEYS.forEach(function(k){
      if (!refs[k]) missing.push(IDS[k]);
    });

    return missing;
  }

  function commonAncestor(nodes) {
    nodes = (nodes || []).filter(Boolean);
    if (!nodes.length) return null;

    var p = nodes[0];
    while (p && p !== document.body) {
      if (nodes.every(function(n){ return p.contains(n); })) return p;
      p = p.parentElement;
    }
    return null;
  }

  function containsCoreRef(node) {
    if (!node) return false;

    return CORE_REF_KEYS.some(function(k){
      var core = refs[k] || document.getElementById(IDS[k]);
      return !!(core && core !== node && node.contains(core));
    });
  }

  function compactFieldRootForSelect(sel, labelText) {
    if (!sel) return null;

    var wanted = clean(labelText).toLowerCase();
    var best = sel.parentElement || sel;
    var p = best;

    /* Climb only a few levels and stop at the smallest wrapper that
       contains this single select plus the expected field label. */
    for (var i=0; i<4 && p && p!==document.body; i++,p=p.parentElement) {
      var selectCount = qa("select",p).length;
      var text = clean(p.textContent).toLowerCase();

      if (selectCount === 1 && text.indexOf(wanted) !== -1) {
        best = p;
        break;
      }
    }

    return best;
  }

  function selectOptionText(sel) {
    if (!sel) return "";

    return qa("option",sel)
      .map(function(opt){
        return clean(opt.textContent).toLowerCase();
      })
      .join(" | ");
  }

  function findSelectBySignature(testFn) {
    var scope =
      document.getElementById("ProductSection") ||
      document.querySelector("form[action*='/cart/add']") ||
      document;

    return qa("select",scope).find(function(sel){
      return !!testFn(sel, selectOptionText(sel));
    }) || null;
  }

  function findSpacerFinishRoot() {
    var direct = document.getElementById(IDS.columnSpacerFinish);

    if (direct) {
      if (sourceSelect(direct) || sourceInputs(direct).length) return direct;
    }

    var sel = findSelectBySignature(function(node,text){
      var descriptor = clean(
        (node.name || "") + " " +
        (node.id || "") + " " +
        (node.getAttribute("data-name") || "") + " " +
        (node.getAttribute("aria-label") || "")
      ).toLowerCase();

      if (
        /column.*spacer.*finish/.test(descriptor) ||
        text.indexOf("choose column spacer finish") !== -1 ||
        text.indexOf("choose garage series column spacer finish") !== -1
      ) {
        return true;
      }

      /* Value-signature fallback. This field is uniquely the three
         spacer finishes we created. */
      return (
        text.indexOf("machine finish") !== -1 &&
        text.indexOf("satin black") !== -1 &&
        text.indexOf("polished") !== -1
      );
    });

    if (!sel) return null;

    if (!sel.id) sel.id = IDS.columnSpacerFinish;
    return sel;
  }

  function findCareKitRoot() {
    var direct = document.getElementById(IDS.careKit);

    if (direct) {
      if (sourceSelect(direct) || sourceInputs(direct).length) return direct;
    }

    var sel = findSelectBySignature(function(node,text){
      var descriptor = clean(
        (node.name || "") + " " +
        (node.id || "") + " " +
        (node.getAttribute("data-name") || "") + " " +
        (node.getAttribute("aria-label") || "")
      ).toLowerCase();

      return (
        /steering.*wheel.*care.*kit/.test(descriptor) ||
        text.indexOf("choose steering wheel care kit") !== -1
      );
    });

    if (!sel) return null;

    if (!sel.id) sel.id = IDS.careKit;
    return sel;
  }

  function resolveAccessoryRef(key) {
    if (key === "careKit") {
      return findCareKitRoot();
    }

    return document.getElementById(IDS[key]);
  }


  function optionControlScope(root) {
    if (!root) return null;
    if (root.matches('select,input[type="radio"],input[type="checkbox"],input[type="file"]') ||
        q('select,input[type="radio"],input[type="checkbox"],input[type="file"]',root)) return root;
    var p=root.parentElement;
    for (var i=0;i<3 && p && p!==sourceHost && p!==document.body;i++,p=p.parentElement) {
      if (p.matches('form,#ProductSection,.product-single,.product-single__meta')) break;
      if (Object.keys(IDS).some(function(key) {
        var other=document.getElementById(IDS[key]);
        return other && other!==root && p.contains(other);
      })) break;
      var controls=qa('select,input[type="radio"],input[type="checkbox"]',p);
      if (controls.length && (controls.length===1 || controls.every(function(n) {
        return n.tagName==='INPUT' && n.name && n.name===controls[0].name;
      }))) return p;
    }
    return root;
  }

  function optionPresentation(root) {
    if (!root) return null;
    if (!root.matches('select,input')) return root;
    var p=root.parentElement;
    for (var i=0;i<4 && p && p!==document.body;i++,p=p.parentElement) {
      if (p.matches('form,#ProductSection,.product-single,.product-single__meta') ||
          Object.keys(IDS).some(function(key) {
            var other=refs[key];
            return other && other!==root && p.contains(other);
          })) break;
      if (p.matches('.hulkapps_option,.hulkapps_option_wrap,.hulkapps_option-wrapper,.hulkapps_option_container') ||
          q('.hulkapps_swatch_option,label[for]',p)) return p;
    }
    return root.parentElement || root;
  }

  function hideLiveSourceRefs() {
    Object.keys(refs).forEach(function(key) {
      var root=refs[key];
      [root,optionPresentation(root)].forEach(function(node) {
        if (node && panel && !panel.contains(node) && !node.contains(panel) &&
            !node.matches('form,#ProductSection,.product-single,.product-single__meta')) {
          node.classList.add('sparc-source-hidden');
        }
      });
    });
  }

  function selectionCard(className,value) {
    var card=el('div',className);
    var select=el('button','sparc-card-select','');
    select.type='button';
    select.setAttribute('aria-label','Select '+friendly(value));
    card.appendChild(select);
    return card;
  }

  function sourceSelect(root) {
    var scope=optionControlScope(root);
    return scope ? (scope.tagName==='SELECT' ? scope : q('select',scope)) : null;
  }

  function sourceInputs(root) {
    var scope=optionControlScope(root);
    if (!scope) return [];
    return scope.matches('input[type="radio"],input[type="checkbox"]')
      ? [scope] : qa('input[type="radio"],input[type="checkbox"]',scope);
  }

  function sourceVisible(root) {
    if (!root || !root.isConnected) return false;
    /* Check the conditional option wrapper itself, then its ancestors.
       Native controls may be hidden solely by Hulk's swatch renderer; in
       that case the rendered option block owns conditional visibility.
       SPARC clips source UI offscreen without changing display/visibility. */
    var p=root.matches('select,input') ? optionPresentation(root) : root;
    for (;p && p!==document.body;p=p.parentElement) {
      var style=getComputedStyle(p);
      if (style.display==='none' || style.visibility==='hidden' || p.hidden ||
          p.getAttribute('aria-hidden')==='true') return false;
    }
    return true;
  }

  function labelForInput(input, root) {
    if (input && input.id) {
      try {
        var lab = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (lab) return lab;
      } catch(e) {}
    }
    return input ? (input.closest("label") || q("label",root)) : null;
  }

  function choiceContainer(input, root) {
    var p = input;
    for (var i=0;i<5 && p && p!==root;i++,p=p.parentElement) {
      if (q("img",p)) return p;
    }
    return labelForInput(input,root) || (input && input.parentElement);
  }

  function cssUrl(value) {
    if (!value || value === "none") return "";
    var m = String(value).match(/url\((['"]?)(.*?)\1\)/i);
    return m ? m[2] : "";
  }

  function pseudoMediaUrl(node, pseudo) {
    if (!node) return "";

    try {
      var style = getComputedStyle(node, pseudo);
      var bg = style && style.backgroundImage;
      return cssUrl(bg);
    } catch(e) {
      return "";
    }
  }

  function mediaUrl(node) {
    if (!node) return "";

    if (node.tagName === "IMG") {
      return (
        node.currentSrc ||
        node.src ||
        node.getAttribute("data-src") ||
        node.getAttribute("data-lazy-src") ||
        node.getAttribute("data-original") ||
        ""
      );
    }

    var attrs = [
      "data-src",
      "data-image",
      "data-image-url",
      "data-original",
      "data-lazy-src",
      "data-bg",
      "data-background"
    ];

    for (var i=0; i<attrs.length; i++) {
      var val = node.getAttribute && node.getAttribute(attrs[i]);
      if (val && /^https?:|^\/|^\/\//.test(val)) return val;
    }

    var inlineBg = node.style && node.style.backgroundImage;
    var u = cssUrl(inlineBg);
    if (u) return u;

    try {
      u = cssUrl(getComputedStyle(node).backgroundImage);
      if (u) return u;
    } catch(e) {}

    return "";
  }

  function isUtilityIcon(node) {
    var descriptor = (
      (node.className || "") + " " +
      (node.id || "") + " " +
      (node.getAttribute && node.getAttribute("alt") || "") + " " +
      (node.getAttribute && node.getAttribute("title") || "")
    ).toLowerCase();

    return /tooltip|info|question|help|icon-info|fa-info/.test(descriptor);
  }

  function mediaCandidates(scope) {
    if (!scope) return [];

    var nodes = [scope].concat(
      qa("img,[style*='background'],[data-src],[data-image],[data-image-url],[data-original],[data-lazy-src],[data-bg],[data-background]", scope)
    );

    var results = [];

    nodes.forEach(function(node) {
      if (!node || isUtilityIcon(node)) return;

      var urls = [
        mediaUrl(node),
        pseudoMediaUrl(node, "::before"),
        pseudoMediaUrl(node, "::after")
      ].filter(Boolean);

      urls.forEach(function(url) {
        var lower = String(url).toLowerCase();

        /* Never use obvious UI/icon imagery as a product option photo. */
        if (/tooltip|info-icon|question|help-icon|icon-info/.test(lower)) return;

        if (!results.some(function(x){ return x.url === url; })) {
          results.push({ node: node, url: url });
        }
      });
    });

    return results;
  }

  function scopeHasSingleChoice(scope, root) {
    if (!scope) return false;
    var inputs = sourceInputs(scope);
    if (inputs.length === 1) return true;

    /* If the input itself is outside the queried subtree, count only the
       source inputs that also belong to this Hulk option root. */
    var optionInputs = sourceInputs(root);
    var inside = optionInputs.filter(function(input){ return scope.contains(input); });
    return inside.length === 1;
  }

  function exactChoiceScopes(input, root) {
    var scopes = [];

    function add(node) {
      if (!node || node === document.body) return;
      if (scopes.indexOf(node) === -1) scopes.push(node);
    }

    var label = labelForInput(input, root);
    add(label);

    if (input) {
      add(input.parentElement);
      add(input.previousElementSibling);
      add(input.nextElementSibling);

      if (input.parentElement) {
        add(input.parentElement.previousElementSibling);
        add(input.parentElement.nextElementSibling);
      }
    }

    /* Find the smallest ancestor that clearly belongs to ONE Hulk value.
       This is the safest place to look for the uploaded image. */
    var p = input ? input.parentElement : null;
    for (var i=0; i<6 && p && p!==root && p!==document.body; i++, p=p.parentElement) {
      if (scopeHasSingleChoice(p, root)) add(p);
    }

    /* Root is intentionally NOT added as a fallback. Searching the whole
       option root by index is what caused images to shift onto wrong values. */
    return scopes;
  }

  function bestMediaFromScope(scope) {
    var candidates = mediaCandidates(scope);
    if (!candidates.length) return "";

    /* Prefer actual IMG tags or elements with image-ish class names. */
    candidates.sort(function(a,b) {
      function score(item) {
        var node = item.node;
        var s = 0;
        if (node && node.tagName === "IMG") s += 100;

        var desc = (
          (node && node.className || "") + " " +
          (node && node.id || "")
        ).toLowerCase();

        if (/swatch|image|img|option|thumbnail|thumb/.test(desc)) s += 25;

        if (node && node.getBoundingClientRect) {
          var r = node.getBoundingClientRect();
          if (r.width >= 25 && r.height >= 25) s += 10;
        }

        return s;
      }
      return score(b) - score(a);
    });

    return candidates[0].url || "";
  }

  function findMediaForInput(input, root) {
    var scopes = exactChoiceScopes(input, root);

    for (var i=0; i<scopes.length; i++) {
      var url = bestMediaFromScope(scopes[i]);
      if (url) return url;
    }

    return "";
  }

  function findMediaForValue(root,value,index) {
    var presentation=optionPresentation(root);
    if (!presentation) return '';
    var wanted=normalizeAccessoryValue(value);
    var sel=sourceSelect(root);
    var opt=sel && qa('option',sel).find(function(n){return n.value===String(value);});
    var direct=opt && mediaUrl(opt);
    if (direct) return direct;
    var input=sourceInputs(root).find(function(n){return n.value===String(value);});
    if (input) {
      var label=input.id && q('label[for="'+CSS.escape(input.id)+'"]',presentation);
      label=label || input.closest('label');
      var url=label && bestMediaFromScope(label);
      if (url) return url;
      var p=input.parentElement;
      for (var i=0;i<4 && p && presentation.contains(p);i++,p=p.parentElement) {
        var all=qa('input[type="radio"],input[type="checkbox"]',p);
        if (all.length!==1 || all[0]!==input) break;
        url=bestMediaFromScope(p);
        if (url) return url;
      }
    }
    /* Pair separated swatches by their exact value/label, never image order. */
    var matches=qa('.hulkapps_swatch_option,[data-value],label',presentation).filter(function(n) {
      if (panel && panel.contains(n)) return false;
      return ['data-value','data-option-value','aria-label'].some(function(attr) {
        var value=n.getAttribute(attr);
        return value && normalizeAccessoryValue(value)===wanted;
      }) || normalizeAccessoryValue(n.textContent)===wanted;
    });
    for (var j=0;j<matches.length;j++) {
      var image=bestMediaFromScope(matches[j]);
      if (image) return image;
    }
    return '';
  }

  function parsePrice(text) {
    var m = String(text || "").match(/([+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?)/);
    if (!m) return "";
    var s = m[1].replace(/\s+/g,"");
    var amount = parseFloat(s.replace(/[+$,]/g,""));
    if (!isNaN(amount) && amount === 0) return "Included";
    if (s.charAt(0)==="$") s = "+" + s;
    return s;
  }

  function choices(root) {
    if (!root) return [];

    var sel = sourceSelect(root);
    if (sel) {
      return qa("option",sel).filter(function(o){ return o.value!==""; }).map(function(o,index){
        return {
          value:o.value,
          label:o.value,
          price:parsePrice(o.textContent),
          image:findMediaForValue(root,o.value,index),
          selected:o.selected
        };
      });
    }

    var inputs = sourceInputs(root);

    return inputs.map(function(input,index){
      var c = choiceContainer(input,root);

      return {
        value:input.value,
        label:input.value,
        price:parsePrice(c && c.textContent),
        image:findMediaForValue(root,input.value,index),
        selected:!!input.checked
      };
    });
  }

  function current(root) {
    if (!root) return '';
    var sel=sourceSelect(root);
    if (sel) return sel.value || '';
    var checked=sourceInputs(root).find(function(n){return n.checked;});
    return checked ? checked.value : '';
  }

  function setSelectChoice(sel,wanted) {
    if (!sel) return false;

    var wantedNorm = normalizeAccessoryValue(wanted);
    var opts = qa("option",sel);

    var match = opts.find(function(opt){
      return normalizeAccessoryValue(opt.value) === wantedNorm;
    });

    if (!match) {
      match = opts.find(function(opt){
        var txt = normalizeAccessoryValue(opt.textContent);

        return (
          txt === wantedNorm ||
          txt.indexOf(wantedNorm + " ") === 0 ||
          txt.indexOf(wantedNorm + "+") === 0
        );
      });
    }

    if (!match) return false;

    opts.forEach(function(opt){
      opt.selected = (opt === match);
    });

    sel.selectedIndex = opts.indexOf(match);

    sel.dispatchEvent(
      new Event("input",{bubbles:true})
    );
    sel.dispatchEvent(
      new Event("change",{bubbles:true})
    );

    /* Hulk is commonly loaded with jQuery on this theme. Native events are
       the primary path; this only helps app handlers that subscribed through
       jQuery-specific change hooks. */
    if (
      window.jQuery &&
      typeof window.jQuery === "function"
    ) {
      try {
        window.jQuery(sel).trigger("change");
      } catch(e) {}
    }

    delayedSync();
    return true;
  }

  function choose(root,value) {
    if (!root) return;
    root=document.getElementById(root.id) || root;
    if (!sourceVisible(root)) return;
    var sel=sourceSelect(root);
    if (sel) {
      setSelectChoice(sel,value);
      return;
    }
    var input=sourceInputs(root).find(function(x){return String(x.value)===String(value) || valueEquals(x.value,value);});
    if (input) {
      if (!input.checked) input.click();
      input.dispatchEvent(new Event("input",{bubbles:true}));
      input.dispatchEvent(new Event("change",{bubbles:true}));
      delayedSync();
    }
  }

  function clearChoice(root) {
    if (!root) return false;

    var sel = sourceSelect(root);
    if (sel) {
      if (!sel.value) return false;

      var blank = qa("option",sel).find(function(o){
        return o.value === "";
      });

      if (blank) {
        sel.value = "";
      } else {
        sel.selectedIndex = -1;
      }

      sel.dispatchEvent(new Event("input",{bubbles:true}));
      sel.dispatchEvent(new Event("change",{bubbles:true}));
      delayedSync();
      return true;
    }

    var changed = false;
    sourceInputs(root).forEach(function(input){
      if (input.checked) {
        input.checked = false;
        changed = true;
        input.dispatchEvent(new Event("input",{bubbles:true}));
        input.dispatchEvent(new Event("change",{bubbles:true}));
      }
    });

    if (changed) delayedSync();
    return changed;
  }

  function getState() {
    var state={};
    Object.keys(IDS).forEach(function(key) {
      state[key]=sourceVisible(refs[key]) ? current(refs[key]) : '';
    });
    return state;
  }

  function configuredPrice() {
    var txt = (document.body.innerText || "").replace(/\u00a0/g," ");
    var matches = txt.match(/Total price is\s*\$[\d,]+(?:\.\d{2})?/ig);
    if (matches && matches.length) {
      var last = matches[matches.length-1];
      var m = last.match(/\$[\d,]+(?:\.\d{2})?/);
      if (m) return m[0];
    }
    return "—";
  }

  /* ==========================================================
     SPARC LEAD-TIME METAOBJECT ENGINE
     Source of truth: Shopify metaobjects emitted by Liquid.
     ========================================================== */

  function leadDebugEnabled() {
    try {
      return (
        new URLSearchParams(window.location.search)
          .get("sparc_lead_debug") === "1"
      );
    } catch (e) {
      return false;
    }
  }

  function ruleDebugRow(rule) {
    if (!rule) return null;

    return {
      ruleName: rule.ruleName,
      scope: rule.seriesScope,
      productHandle: rule.productHandle,
      selectorId: rule.selectorId,
      optionValue: rule.optionValue,
      normalizedValue: normalizeRuleValue(rule.optionValue),
      minimum: rule.minimum,
      maximum: rule.maximum,
      unit: rule.unit,
      customerMessage: rule.customerMessage,
      valid: validLeadRule(rule)
    };
  }

  var leadTimeDataCache = null;
  var leadTimeDataMissingLogged = false;

  function leadTimeData() {
    if (leadTimeDataCache) return leadTimeDataCache;

    var node = document.getElementById(
      "sparc-configurator-lead-time-data"
    );

    if (!node) {
      if (!leadTimeDataMissingLogged) {
        leadTimeDataMissingLogged = true;
        console.warn(
          "[SPARC GARAGE V1.7] Lead-time JSON bridge was not found on the page."
        );
      }
      return null;
    }

    try {
      leadTimeDataCache = JSON.parse(node.textContent || "{}");
      leadTimeDataCache.seriesScope = SERIES_SCOPE;
      return leadTimeDataCache;
    } catch (e) {
      console.error(
        "[SPARC GARAGE V1.7] Lead-time JSON could not be parsed.",
        e
      );
      return null;
    }
  }

  function normalizeLeadUnit(unit) {
    var u = String(unit || "").trim().toLowerCase();

    if (u === "day" || u === "days") return "days";
    if (u === "week" || u === "weeks" || u === "wk" || u === "wks") {
      return "weeks";
    }

    return "";
  }

  function normalizeSelectorId(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .trim()
      .toLowerCase();
  }

  function normalizeRuleValue(value) {
    if (value === null || value === undefined) return "";

    var text = String(value)
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ");

    /* Apply our existing friendly names first. */
    text = friendly(text);

    /* Hulk can decorate values in several formats. Remove ANY price-looking
       fragment rather than relying on one exact decoration pattern. */
    text = String(text)
      .replace(/[[(|]?\s*[+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?\s*[\])|]?/g, " ")
      .replace(/\s+[+\-]\s*[\d,]+(?:\.\d{1,2})?\s*$/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    /* Normalize common punctuation that Hulk can inject between label parts. */
    text = text
      .replace(/\s*[|•·]\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return text;
  }

  function ruleValueMatches(ruleValue, selectedValue) {
    var rule = normalizeRuleValue(ruleValue);
    var selected = normalizeRuleValue(selectedValue);

    if (!rule || !selected) return false;
    if (rule === selected) return true;

    /* Defensive fallback for Hulk strings that retain non-price decoration.
       Only accept a boundary-prefixed match, never arbitrary substring. */
    if (
      selected.indexOf(rule + " ") === 0 ||
      selected.indexOf(rule + " -") === 0 ||
      selected.indexOf(rule + ":") === 0
    ) {
      return true;
    }

    return false;
  }

  function ruleComparisonDays(rule) {
    var unit = normalizeLeadUnit(rule && rule.unit);
    var min = Number(rule && rule.minimum) || 0;
    var max = Number(rule && rule.maximum) || 0;

    if (unit === "weeks") {
      min *= 7;
      max *= 7;
    }

    return {
      min: min,
      max: max
    };
  }

  function validLeadRule(rule) {
    if (!rule) return false;

    var unit = normalizeLeadUnit(rule.unit);
    var min = Number(rule.minimum);
    var max = Number(rule.maximum);

    return !!(
      unit &&
      isFinite(min) &&
      isFinite(max) &&
      min >= 0 &&
      max >= min
    );
  }

  function ruleSpecificity(rule, data) {
    if (!rule || !data) return -1;

    var scope = String(rule.seriesScope || "").toLowerCase();
    var productHandle = String(rule.productHandle || "");

    /* Highest priority: exact product reference. */
    if (
      productHandle &&
      productHandle === String(data.productHandle || "")
    ) {
      return 300;
    }

    /* Series-specific rule. */
    if (
      scope &&
      scope === String(data.seriesScope || "").toLowerCase()
    ) {
      return 200;
    }

    /* Shared rule. */
    if (scope === "shared") {
      return 100;
    }

    return -1;
  }

  function matchingRule(selectorId, optionValue) {
    var data = leadTimeData();
    if (!data || !Array.isArray(data.rules)) return null;

    var selector = normalizeSelectorId(selectorId);

    var selectorRules = data.rules.filter(function(rule) {
      if (!validLeadRule(rule)) return false;

      return (
        normalizeSelectorId(rule.selectorId) === selector &&
        ruleSpecificity(rule, data) >= 0
      );
    });

    var matches = selectorRules.filter(function(rule) {
      return ruleValueMatches(rule.optionValue, optionValue);
    });

    if (!matches.length) {
      if (leadDebugEnabled()) {
        console.warn(
          "[SPARC GARAGE V1.7] No rule match",
          {
            selectorId: selectorId,
            selectedValue: optionValue,
            normalizedSelector: selector,
            normalizedSelectedValue: normalizeRuleValue(optionValue),
            candidateRules: selectorRules.map(function(rule) {
              return {
                ruleName: rule.ruleName,
                selectorId: rule.selectorId,
                optionValue: rule.optionValue,
                normalizedOptionValue: normalizeRuleValue(rule.optionValue),
                min: rule.minimum,
                max: rule.maximum,
                unit: rule.unit
              };
            })
          }
        );
      }

      return null;
    }

    matches.sort(function(a, b) {
      return (
        ruleSpecificity(b, data) -
        ruleSpecificity(a, data)
      );
    });

    return matches[0];
  }

  function baseLeadRule() {
    return matchingRule("base", "base");
  }

  function activeLeadSelections(s) {
    return Object.keys(IDS).filter(function(key) {
      return sourceVisible(refs[key]) && s[key] &&
        (key!=='careKit' || valueEquals(s[key],'Yes'));
    }).map(function(key) {return {selectorId:IDS[key],value:s[key]};});
  }

  function activeLeadMessages(s) {
    var data=leadTimeData();

    if (!data || !Array.isArray(data.rules)) {
      return [];
    }

    var selections=activeLeadSelections(s);
    var messages=[];

    function addMessage(rule) {
      if (!rule) return;

      var message=clean(rule.customerMessage || "");
      if (!message) return;

      if (messages.indexOf(message) === -1) {
        messages.push(message);
      }
    }

    selections.forEach(function(selection){
      var selector=
        normalizeSelectorId(selection.selectorId);

      data.rules.forEach(function(rule){
        if (!rule) return;
        if (ruleSpecificity(rule,data) < 0) return;

        if (
          normalizeSelectorId(rule.selectorId) !== selector
        ) return;

        if (
          !ruleValueMatches(
            rule.optionValue,
            selection.value
          )
        ) return;

        addMessage(rule);
      });
    });

    data.rules.forEach(function(rule){
      if (!rule) return;
      if (ruleSpecificity(rule,data) < 0) return;

      if (
        normalizeSelectorId(rule.selectorId) ===
          normalizeSelectorId("base") &&
        ruleValueMatches(rule.optionValue,"base")
      ) {
        addMessage(rule);
      }
    });

    return messages;
  }

  function leadQualifier(s) {
    return activeLeadMessages(s).join(" • ");
  }

  function winningLeadRule(s) {
    var candidates = [];

    var base = baseLeadRule();
    if (base) candidates.push(base);

    activeLeadSelections(s).forEach(function(selection) {
      var rule = matchingRule(
        selection.selectorId,
        selection.value
      );

      if (rule) candidates.push(rule);
    });

    if (!candidates.length) return null;

    candidates.sort(function(a, b) {
      var ac = ruleComparisonDays(a);
      var bc = ruleComparisonDays(b);

      /* Longest maximum wins. */
      if (bc.max !== ac.max) {
        return bc.max - ac.max;
      }

      /* Tie-breaker: longest minimum wins. */
      if (bc.min !== ac.min) {
        return bc.min - ac.min;
      }

      /* Final tie-breaker: most specific rule wins. */
      return (
        ruleSpecificity(b, leadTimeData()) -
        ruleSpecificity(a, leadTimeData())
      );
    });

    return candidates[0];
  }

  function formatLeadRule(rule) {
    if (!validLeadRule(rule)) return "—";

    var min = Number(rule.minimum);
    var max = Number(rule.maximum);
    var unit = normalizeLeadUnit(rule.unit);

    if (unit === "days") {
      if (min === max) {
        return min === 1 ? "1 DAY" : min + " DAYS";
      }

      return min + "–" + max + " DAYS";
    }

    if (unit === "weeks") {
      if (min === max) {
        return min === 1 ? "1 WK" : min + " WKS";
      }

      return min + "–" + max + " WKS";
    }

    return "—";
  }

  function leadTime(s) {
    var winner = winningLeadRule(s);

    if (winner) {
      return formatLeadRule(winner);
    }

    /* Safety fallback only if Liquid/metaobject data is unavailable.
       This should disappear in normal operation once the Base rule exists. */
    if (leadTimeData()) {
      console.warn(
        "[SPARC GARAGE V1.7] Lead-time rules loaded, but no applicable rule was found. " +
        "Check the active Garage Series Base metaobject."
      );
    }

    return "—";
  }

  function renderLeadDebug() {
    if (!leadDebugEnabled()) return;

    var existing = document.getElementById("sparc-lead-debug");

    if (existing) existing.remove();

    var data = leadTimeData();
    var state = getState();
    var selections = activeLeadSelections(state);

    var box = el("div", "");
    box.id = "sparc-lead-debug";
    box.style.cssText =
      "margin:12px 0;padding:12px 14px;border:2px solid #a8874a;" +
      "background:#fff8ea;color:#222;font:11px/1.45 Arial,sans-serif;";

    var html = "<strong>SPARC V36 Lead-Time Debug</strong>";

    if (!data) {
      html += "<br><br><b>ERROR:</b> Lead-time JSON bridge is missing from the page.";
    }

    html += "<br><br><b>Winning rule:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(ruleDebugRow(winningLeadRule(state)), null, 2)
        .replace(/</g,"&lt;") +
      "</pre>";

    html += "<b>Active selections:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(
        selections.map(function(sel) {
          var matched = matchingRule(sel.selectorId, sel.value);

          return {
            selectorId: sel.selectorId,
            rawValue: sel.value,
            normalizedValue: normalizeRuleValue(sel.value),
            matchedRule: matched ? ruleDebugRow(matched) : null
          };
        }),
        null,
        2
      ).replace(/</g,"&lt;") +
      "</pre>";

    html += "<b>Loaded rules:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(
        data && data.rules
          ? data.rules.map(ruleDebugRow)
          : [],
        null,
        2
      ).replace(/</g,"&lt;") +
      "</pre>";

    box.innerHTML = html;

    var mount = document.getElementById("sparc-garage-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }
  }

  function currentLeadTimeRule() {
    return winningLeadRule(getState());
  }



  /* ==========================================================
     SPARC OPTION DETAIL METAOBJECT ENGINE V38
     Source of truth: Shopify metaobjects emitted by Liquid.
     ========================================================== */

  var optionDetailDataCache = null;

  function optionDetailData() {
    if (optionDetailDataCache) return optionDetailDataCache;

    var node = document.getElementById(
      "sparc-configurator-option-detail-data"
    );

    if (!node) {
      return null;
    }

    try {
      optionDetailDataCache = JSON.parse(node.textContent || "{}");
      optionDetailDataCache.seriesScope = SERIES_SCOPE;
      return optionDetailDataCache;
    } catch (e) {
      console.error(
        "[SPARC GARAGE V1.7] Option-detail JSON could not be parsed.",
        e
      );
      return null;
    }
  }

  function optionDetailSpecificity(detail, data) {
    if (!detail || !data) return -1;

    var scope = String(detail.seriesScope || "").toLowerCase();
    var productHandle = String(detail.productHandle || "");

    if (
      productHandle &&
      productHandle === String(data.productHandle || "")
    ) {
      return 300;
    }

    if (
      scope &&
      scope === String(data.seriesScope || "").toLowerCase()
    ) {
      return 200;
    }

    if (scope === "shared") {
      return 100;
    }

    return -1;
  }

  function matchingOptionDetail(selectorId, optionValue) {
    var data = optionDetailData();

    if (!data || !Array.isArray(data.entries)) {
      return null;
    }

    var selector = normalizeSelectorId(selectorId);

    var matches = data.entries.filter(function(detail) {
      if (!detail || detail.enabled !== true) return false;

      if (
        normalizeSelectorId(detail.selectorId) !== selector
      ) {
        return false;
      }

      if (
        !ruleValueMatches(detail.optionValue, optionValue)
      ) {
        return false;
      }

      return optionDetailSpecificity(detail, data) >= 0;
    });

    if (!matches.length) return null;

    matches.sort(function(a,b) {
      return (
        optionDetailSpecificity(b,data) -
        optionDetailSpecificity(a,data)
      );
    });

    return matches[0];
  }

  function selectorImageForOption(root,value,hulkImage) {
    if (hulkImage) return hulkImage;
    var detail=matchingOptionDetail(root && root.id,value);
    return detail && detail.selectorImage || '';
  }

  function popupImagesForOption(root, value, fallbackImage) {
    var detail = matchingOptionDetail(
      root && root.id,
      value
    );

    var images = [];

    if (detail && detail.popupImage) {
      images.push(detail.popupImage);
    } else if (detail && detail.selectorImage) {
      images.push(detail.selectorImage);
    } else if (fallbackImage) {
      images.push(fallbackImage);
    }

    if (
      detail &&
      Array.isArray(detail.popupAdditionalImages)
    ) {
      detail.popupAdditionalImages.forEach(function(url) {
        if (url && images.indexOf(url) === -1) {
          images.push(url);
        }
      });
    }

    return images;
  }

  function accordion(name,num,title) {
    var section=el("section","sparc-accordion");
    section.dataset.section=name;
    var head=el("button","sparc-accordion__head");
    head.type="button";
    head.appendChild(el("span","sparc-step-number",num));
    head.appendChild(el("span","sparc-accordion__title",title));
    head.appendChild(el("span","sparc-required-badge","REQUIRED"));

    head.appendChild(el("span","sparc-accordion__summary",""));
    head.appendChild(el("span","sparc-chevron","⌄"));
    var body=el("div","sparc-accordion__body");
    var inner=el("div","sparc-accordion__inner");
    body.appendChild(inner); section.appendChild(head); section.appendChild(body);

    head.addEventListener("click",function(e){
      e.preventDefault(); e.stopPropagation();
      if(section.classList.contains("is-open")) closeAll();
      else openSection(name);
    });
    return {section:section,inner:inner};
  }

  function makeTab(name,text) {
    var b=el("button","sparc-config-tab",text); b.type="button";
    b.addEventListener("click",function(e){
      e.preventDefault(); e.stopPropagation(); openSection(name);
    });
    tabs[name]=b;
    return b;
  }

  function closeAll() {
    Object.keys(accs).forEach(function(k){ if(accs[k].section) accs[k].section.classList.remove("is-open"); });
    Object.keys(tabs).forEach(function(k){ tabs[k].classList.remove("is-active"); });
    scheduleResize();
  }

  function openSection(name) {
    Object.keys(accs).forEach(function(k){ if(accs[k].section) accs[k].section.classList.toggle("is-open",k===name); });
    Object.keys(tabs).forEach(function(k){ tabs[k].classList.toggle("is-active",k===name); });
    scheduleResize();
  }


  function optionInfoCopy(sectionName, value) {
    var val = friendly(value);

    if (sectionName === "finish") {
      return "See a larger view of " + val + " and compare how this finish changes the appearance of the billet center and spokes.";
    }

    if (sectionName === "grip") {
      return "See a larger view of the " + val + " grip profile. Use the enlarged image to compare the hand position, upper-grip geometry, and overall shape.";
    }

    if (sectionName === "leather") {
      return "See more detail for " + val + ". Leather and grip-finish selections affect both the appearance and final feel of the steering wheel.";
    }

    if (sectionName === "horn") {
      return "See more detail for the " + val + " horn-button treatment and how it affects the finished center appearance.";
    }

    if (sectionName === "mounting") {
      return "See more information about " + val + " and how this mounting choice relates to steering-column fitment.";
    }

    if (sectionName === "accessories") {
      return "See more information about " + val + ", including fitment, finish, and how this optional accessory works with your steering wheel package.";
    }

    return "More information about " + val + ".";
  }

  function sectionNameForRoot(root) {
    if (root === refs.finish) return "finish";
    if (root === refs.grip) return "grip";
    if (root === refs.leatherWrap || root === refs.leatherColor) return "leather";
    if (root === refs.hornLogo) return "horn";
    if (root === refs.adapter || root === refs.hubSleeve) return "mounting";
    if (
      root === refs.columnSpacer ||
      root === refs.columnSpacerFinish ||
      root === refs.careKit
    ) return "accessories";
    return "";
  }

  function addOptionInfoButton(
    container,
    root,
    value,
    imageUrl
  ) {
    if (!container || !root) return;

    var sectionName = sectionNameForRoot(root);

    if (!sectionName) return;

    var button=el(
      "button",
      "sparc-option-info",
      "i"
    );

    button.type="button";
    button.setAttribute(
      "aria-label",
      "More information about " + friendly(value)
    );

    button.addEventListener("click",function(e) {
      e.preventDefault();
      e.stopPropagation();

      var detail = matchingOptionDetail(
        root.id,
        value
      );

      openOptionInfoModal({
        section: sectionName,
        root: root,
        value: value,
        fallbackImage: imageUrl || "",
        detail: detail
      });
    });

    container.appendChild(button);
  }

  function setInfoModalGallery(
    modal,
    images,
    altText
  ) {
    var main = q(
      ".sparc-info-modal__image",
      modal
    );

    var strip = q(
      ".sparc-info-modal__thumbs",
      modal
    );

    images = Array.isArray(images)
      ? images.filter(Boolean)
      : [];

    strip.innerHTML = "";

    if (!images.length) {
      main.removeAttribute("src");
      main.classList.remove("has-image");
      strip.classList.remove("has-images");
      return;
    }

    main.src=images[0];
    main.alt=altText||"";
    main.classList.add("has-image");

    if (images.length > 1) {
      strip.classList.add("has-images");

      images.forEach(function(url,index) {
        var button=el(
          "button",
          "sparc-info-modal__thumb",
          ""
        );

        button.type="button";
        button.classList.toggle(
          "is-active",
          index===0
        );

        var img=document.createElement("img");
        img.src=url;
        img.alt=
          altText
            ? altText + " view " + (index+1)
            : "Option detail view " + (index+1);

        button.appendChild(img);

        button.addEventListener(
          "click",
          function() {
            main.src=url;

            qa(
              ".sparc-info-modal__thumb",
              strip
            ).forEach(function(node) {
              node.classList.remove(
                "is-active"
              );
            });

            button.classList.add(
              "is-active"
            );
          }
        );

        strip.appendChild(button);
      });
    } else {
      strip.classList.remove("has-images");
    }
  }

  function openOptionInfoModal(data) {
    var modal=ensureInfoModal();

    var sectionContent=
      INFO_CONTENT[data.section]||{};

    var detail=
      data.detail ||
      matchingOptionDetail(
        data.root && data.root.id,
        data.value
      );

    q(
      ".sparc-info-modal__eyebrow",
      modal
    ).textContent=
      sectionContent.eyebrow ||
      "Option Information";

    q(
      ".sparc-info-modal__title",
      modal
    ).textContent=
      detail && detail.popupTitle
        ? detail.popupTitle
        : friendly(data.value);

    q(
      ".sparc-info-modal__selection",
      modal
    ).textContent=
      detail && detail.popupDescriptionHeading
        ? detail.popupDescriptionHeading
        : "OPTION DETAILS";

    var copy=q(
      ".sparc-info-modal__copy",
      modal
    );

    if (
      detail &&
      detail.popupDescriptionHtml
    ) {
      copy.innerHTML=
        detail.popupDescriptionHtml;
    } else {
      copy.textContent=
        optionInfoCopy(
          data.section,
          data.value
        );
    }

    var images=popupImagesForOption(
      data.root,
      data.value,
      data.fallbackImage
    );

    setInfoModalGallery(
      modal,
      images,
      detail && detail.imageAltText
        ? detail.imageAltText
        : friendly(data.value)
    );

    if (typeof modal.showModal==='function' && !modal.open) modal.showModal();
    modal.classList.add("is-open");
    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.classList.add(
      "sparc-modal-open"
    );
  }

  function cardGrid(root,cols,isGrip,placeholder) {
    var wrap=el(
      "div",
      "sparc-card-grid " +
      (cols===3?"sparc-card-grid--3":"sparc-card-grid--2")
    );

    choices(root).forEach(function(c) {
      var detail = matchingOptionDetail(root.id,c.value);
      var cardImage = selectorImageForOption(
        root,
        c.value,
        c.image
      );

      var b=selectionCard("sparc-option-card",c.value);
      b.dataset.value=c.value;
      b.dataset.sourceId=root.id;

      b.appendChild(
        el("span","sparc-option-card__check","✓")
      );

      addOptionInfoButton(
        b,
        root,
        c.value,
        cardImage
      );

      var iw=el(
        "div",
        "sparc-option-card__image" +
        (isGrip?" sparc-option-card__image--grip":"")
      );

      if(cardImage) {
        var im=document.createElement("img");
        im.src=cardImage;
        im.alt=
          detail && detail.imageAltText
            ? detail.imageAltText
            : friendly(c.value);
        iw.appendChild(im);
      } else {
        iw.appendChild(
          el(
            "div",
            "sparc-option-card__placeholder",
            placeholder ||
            "Add option image in Hulk Admin"
          )
        );
      }

      b.appendChild(iw);

      var cp=el("div","sparc-option-card__copy");
      cp.appendChild(
        el(
          "span",
          "sparc-option-card__name",
          friendly(c.value)
        )
      );

      var meta=el("div","sparc-option-card__meta");
      meta.appendChild(
        el("span","sparc-option-card__note","")
      );
      var displayPrice=c.price||"";

      if (
        !displayPrice &&
        root &&
        root.id===IDS.finish &&
        normalizeAccessoryValue(c.value)==="machine finish"
      ) {
        displayPrice="Included";
      }

      meta.appendChild(
        el(
          "span",
          "sparc-option-card__price",
          displayPrice
        )
      );

      cp.appendChild(meta);
      b.appendChild(cp);

      b.addEventListener("click",function(e) {
        e.preventDefault();
        e.stopPropagation();
        choose(root,c.value);
      });

      wrap.appendChild(b);
    });

    return wrap;
  }

  function optionalAccessoryToggleCard(root,yesValue,noValue,title,description) {
    var wrap=el("div","sparc-accessory-toggle-grid");
    var yesChoice=choices(root).find(function(c){
      return valueEquals(c.value,yesValue);
    });

    if (!yesChoice) return wrap;

    var detail = matchingOptionDetail(root.id,yesChoice.value);
    var cardImage = selectorImageForOption(
      root,
      yesChoice.value,
      yesChoice.image
    );

    var button=selectionCard("sparc-option-card sparc-accessory-toggle-card",title);
    button.dataset.value=yesChoice.value;
    button.dataset.sourceId=root.id;

    button.appendChild(
      el("span","sparc-option-card__check","✓")
    );

    addOptionInfoButton(
      button,
      root,
      yesChoice.value,
      cardImage
    );

    var iw=el("div","sparc-option-card__image sparc-accessory-toggle-card__image");

    if(cardImage) {
      var im=document.createElement("img");
      im.src=cardImage;
      im.alt=
        detail && detail.imageAltText
          ? detail.imageAltText
          : title;
      iw.appendChild(im);
    } else {
      iw.appendChild(
        el(
          "div",
          "sparc-option-card__placeholder",
          "Add care kit image in Hulk Admin"
        )
      );
    }

    button.appendChild(iw);

    var cp=el("div","sparc-option-card__copy");
    cp.appendChild(
      el("span","sparc-option-card__name",title)
    );

    if (description) {
      cp.appendChild(
        el("span","sparc-accessory-toggle-card__description",description)
      );
    }

    var meta=el("div","sparc-option-card__meta");
    meta.appendChild(el("span","sparc-option-card__note","Optional"));
    meta.appendChild(
      el("span","sparc-option-card__price",yesChoice.price||"")
    );
    cp.appendChild(meta);
    button.appendChild(cp);

    button.dataset.accessoryKey="careKit";

    button.addEventListener("click",function(e){
      if (e.__sparcCareHandled) return;

      e.preventDefault();
      e.stopPropagation();

      var liveRoot=currentAccessoryRoot("careKit");
      if (!liveRoot) return;

      var nextValue =
        valueEquals(current(liveRoot),yesValue)
          ? noValue
          : yesValue;

      choose(liveRoot,nextValue);

      requestAnimationFrame(function(){
        var currentRoot=currentAccessoryRoot("careKit");
        if (currentRoot) {
          syncChoiceClasses(
            currentRoot,
            accs.accessories.section
          );
        }
      });
    });

    wrap.appendChild(button);
    return wrap;
  }

  function choiceGrid(root,metaMap) {
    var wrap=el("div","sparc-choice-grid");
    choices(root).forEach(function(c){
      var m=(metaMap&&metaMap[c.value])||{};
      var b=el("button","sparc-choice"); b.type="button"; b.dataset.value=c.value; b.dataset.sourceId=root.id;
      b.appendChild(el("span","sparc-choice__title",m.title||friendly(c.value)));
      b.appendChild(el("span","sparc-choice__sub",m.sub||c.price||""));
      b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();choose(root,c.value);});
      wrap.appendChild(b);
    });
    return wrap;
  }

  function stitchGrid(root) {
    var wrap=el("div","sparc-stitch-grid");
    choices(root).forEach(function(c){
      var b=el("button","sparc-stitch"); b.type="button"; b.dataset.value=c.value; b.dataset.sourceId=root.id;
      var t=el("span","sparc-stitch__thread"); t.style.background=STITCH_COLORS[c.value]||"#777";
      b.appendChild(t); b.appendChild(el("span","sparc-stitch__name",c.value));
      b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();choose(root,c.value);});
      wrap.appendChild(b);
    });
    return wrap;
  }

  function mirrorSelect(root,labelText,help) {
    var field=el("div","sparc-field");
    field.appendChild(el("label","sparc-field__label",labelText));
    var mirror=document.createElement("select"); mirror.className="sparc-select";
    var ss=sourceSelect(root);
    if(ss) {
      qa("option",ss).forEach(function(o){
        var op=document.createElement("option");op.value=o.value;op.textContent=o.textContent;mirror.appendChild(op);
      });
      mirror.value=ss.value;
      mirror.addEventListener("change",function(e){e.stopPropagation();choose(root,mirror.value);});
    }
    field.appendChild(mirror);
    if(help) field.appendChild(el("div","sparc-field__help",help));
    field._mirror=mirror;
    return field;
  }

  function conditional() {
    var o=el("div","sparc-conditional");
    o.appendChild(el("div","sparc-conditional__inner"));
    return o;
  }

  function hideGarageLegacyGripFinishLabel() {
    var finish=refs.finish;

    if (!finish) return;

    var panel=
      document.getElementById(
        "sparc-garage-configurator"
      );

    /*
      The old Garage Hulk radio markup renders the visible "Grip Finish *"
      label as a sibling/nearby node outside the option root. Because that
      label is not technically inside refs.finish, the generic source hiding
      leaves it behind below Quantity.

      Only inspect compact text nodes near the hidden finish source and hide
      the exact Garage field label. Do not hide the configurator's own
      "GRIP FINISH" accordion title.
    */
    var rootRect=
      finish.getBoundingClientRect();

    qa("*",document).forEach(function(node){
      if (
        !node ||
        node === finish ||
        finish.contains(node) ||
        (panel && panel.contains(node))
      ) {
        return;
      }

      var text=
        clean(
          node.textContent
        );

      if (
        !/^Grip Finish\s*\*?$/i.test(text)
      ) {
        return;
      }

      var rect=
        node.getBoundingClientRect();

      if (
        rect.width <= 0 ||
        rect.height <= 0 ||
        rect.width > 260 ||
        rect.height > 70
      ) {
        return;
      }

      /*
        Keep this local to the original product-options area.
        The label may move when Hulk re-renders, so allow a generous
        vertical range around the source field but not the whole page.
      */
      var nearFinish=
        Math.abs(
          rect.top - rootRect.top
        ) < 600;

      if (!nearFinish) return;

      node.style.setProperty(
        "display",
        "none",
        "important"
      );

      node.setAttribute(
        "data-sparc-garage-legacy-grip-label-hidden",
        "true"
      );
    });
  }

  function hideLegacyDecorations() {
    qa("*",document).forEach(function(n){
      if(panel && panel.contains(n)) return;
      if(n.children.length<=1 && /^Choose Your Product Options:?$/i.test(clean(n.textContent))) {
        n.classList.add("sparc-source-decoration-hidden");
      }
      if(n.children.length<=3 && /^Total price is\s*\$[\d,]+(?:\.\d{2})?$/i.test(clean(n.textContent))) {
        n.classList.add("sparc-source-decoration-hidden");
      }
    });

    hideGarageLegacyGripFinishLabel();
  }


  function debugImageData() {
    var params = new URLSearchParams(window.location.search);
    if (params.get("sparc_debug") !== "1") return;

    var old = document.getElementById("sparc-image-debug");
    if (old) old.remove();

    var box = el("div", "");
    box.id = "sparc-image-debug";

    function rows(root, title) {
      var html = "<strong>" + title + "</strong>";
      var ch = choices(root);
      var inputs = sourceInputs(root);

      ch.forEach(function(c) {
        var input = inputs.find(function(x){
          return String(x.value) === String(c.value);
        });

        var label = input ? labelForInput(input, root) : null;

        html += "<code>" +
          c.value.replace(/</g,"&lt;") +
          " -> " +
          (c.image ? c.image.replace(/</g,"&lt;") : "[NO EXACT IMAGE URL FOUND]") +
          "</code><br>";

        if (!c.image && label) {
          var snippet = label.outerHTML || "";
          snippet = snippet.slice(0,900)
            .replace(/&/g,"&amp;")
            .replace(/</g,"&lt;")
            .replace(/>/g,"&gt;");

          html += "<code>label HTML: " + snippet + "</code><br>";
        }
      });

      return html;
    }

    box.innerHTML =
      "<b>SPARC V23 Exact Hulk Image Debug</b>" +
      rows(refs.finish,"Finish") +
      rows(refs.grip,"Grip") +
      rows(refs.leatherColor,"Leather Color");

    var mount = document.getElementById("sparc-garage-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }

    console.info("[SPARC GARAGE V1.7] Finish media", choices(refs.finish));
    console.info("[SPARC GARAGE V1.7] Grip media", choices(refs.grip));
    console.info("[SPARC GARAGE V1.7] Leather Color media", choices(refs.leatherColor));
  }


  function findCustomLaserFileSource() {
    var files = qa('input[type="file"]', document);

    if (!files.length) return null;

    var candidates = files.map(function(input) {
      var score = 0;
      var p = input.parentElement;
      var bestWrapper = input.parentElement;

      var descriptor = clean(
        (input.name || "") + " " +
        (input.id || "") + " " +
        (input.className || "") + " " +
        (input.getAttribute("data-name") || "") + " " +
        (input.getAttribute("data-label") || "")
      ).toLowerCase();

      if (/custom laser marking/.test(descriptor)) score += 200;
      if (/laser|marking/.test(descriptor)) score += 90;
      if (/custom|logo/.test(descriptor)) score += 50;

      for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
        var text = clean(p.textContent).toLowerCase();

        if (/custom laser marking/.test(text)) score += 180;
        else if (/laser.*mark|custom.*mark/.test(text)) score += 100;
        else if (/laser|marking|custom logo/.test(text)) score += 35;

        if (
          bestWrapper &&
          clean(p.textContent).length &&
          clean(p.textContent).length < clean(bestWrapper.textContent).length
        ) {
          bestWrapper = p;
        }
      }

      return {
        input: input,
        wrapper: bestWrapper || input.parentElement,
        score: score
      };
    });

    candidates.sort(function(a,b){ return b.score - a.score; });

    if (candidates[0] && (candidates[0].score > 0 || files.length === 1)) {
      return candidates[0];
    }

    return null;
  }

  function customUploadBlock() {
    var outer = el("div", "sparc-custom-upload is-hidden");

    outer.appendChild(
      el(
        "span",
        "sparc-custom-upload__label",
        "CUSTOM HORN LOGO ARTWORK"
      )
    );

    outer.appendChild(
      el(
        "div",
        "sparc-custom-upload__help",
        "Upload the artwork file SPARC should use for your custom horn-button laser marking. Vector artwork is preferred when available."
      )
    );

    var input = document.createElement("input");
    input.type = "file";
    input.className = "sparc-custom-upload__input";
    input.accept = ".ai,.eps,.svg,.pdf,.png,.jpg,.jpeg";

    var status = el(
      "div",
      "sparc-custom-upload__status",
      "No file selected"
    );

    outer.appendChild(input);
    outer.appendChild(status);

    outer._sparcProxyInput = input;
    outer._sparcStatus = status;
    outer._sparcProxyFile = null;
    outer._sparcFileInput = null;
    outer._sparcSourceWrapper = null;

    input.addEventListener("change", function() {
      outer._sparcProxyFile =
        input.files && input.files.length
          ? input.files[0]
          : null;

      status.classList.remove("is-ok","is-error");

      if (!outer._sparcProxyFile) {
        status.textContent = "No file selected";
        if (sparcValidationAttempted) applyValidationState();
        return;
      }

      status.textContent = outer._sparcProxyFile.name;

      function finishStatus(ok) {
        status.classList.remove("is-ok","is-error");

        if (ok) {
          status.classList.add("is-ok");
          status.textContent = outer._sparcProxyFile.name + " · ready";
        } else {
          status.textContent = outer._sparcProxyFile.name + " · connecting to product upload field…";
        }

        if (sparcValidationAttempted) applyValidationState();
      }

      var synced = syncProxyFileToHulk();
      finishStatus(synced);

      if (!synced) {
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },150);
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },500);
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },1000);
      }
    });

    return outer;
  }

  function customFileVisualWrapper(input) {
    if (!input) return null;

    var p = input.parentElement;
    var fallback = p;

    for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
      var text = clean(p.textContent);

      if (/Custom Laser Marking/i.test(text)) {
        return p;
      }

      /* Keep a reasonable wrapper fallback containing the input. */
      if (p.contains(input)) fallback = p;
    }

    return fallback;
  }

  function setInputFiles(input, file) {
    if (!input || !file) return false;

    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;

      input.dispatchEvent(new Event("input",{bubbles:true}));
      input.dispatchEvent(new Event("change",{bubbles:true}));

      return !!(
        input.files &&
        input.files.length &&
        input.files[0].name === file.name
      );
    } catch(e) {
      console.warn("[SPARC GARAGE V1.7] Could not mirror file into Hulk input", e);
      return false;
    }
  }

  function syncProxyFileToHulk() {
    if (!accs.customLaserBlock) return false;

    var file = accs.customLaserBlock._sparcProxyFile;

    if (!file) return false;

    var source = findCustomLaserFileSource();

    if (!source || !source.input) return false;

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    var ok = setInputFiles(input,file);

    var status = accs.customLaserBlock._sparcStatus;

    if (status) {
      status.classList.remove("is-ok","is-error");

      if (ok) {
        status.classList.add("is-ok");
        status.textContent = file.name + " · ready";
      } else {
        status.classList.add("is-error");
        status.textContent = file.name + " · upload field not ready";
      }
    }

    return ok;
  }

  /* V33: intentionally no document-wide MutationObserver.
     Continuous observation of Hulk's conditional file field caused browser
     instability when Custom was selected. We use finite retries instead. */
  function watchForCustomUpload() {
    return;
  }


  function connectCustomLaserUpload() {
    if (!accs.customLaserBlock) return false;

    var source = findCustomLaserFileSource();

    if (!source || !source.input) return false;

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    return true;
  }


  function adapterSvg(label) {
    var years = String(label || "").match(/\d{2}[-–]\d{2}/);
    var yr = years ? years[0] : "";

    return (
      '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<circle cx="50" cy="50" r="31" stroke-width="5"/>' +
        '<circle cx="50" cy="50" r="13" stroke-width="4"/>' +
        '<path d="M50 19V36M50 64V81M19 50H36M64 50H81" stroke-width="4" stroke-linecap="round"/>' +
        '<path d="M30 30L41 41M59 59L70 70M70 30L59 41M41 59L30 70" stroke-width="3" stroke-linecap="round"/>' +
        (yr ? '<text x="50" y="96" text-anchor="middle" fill="#55514b" stroke="none" font-size="12" font-family="Arial" font-weight="700">' + yr + '</text>' : '') +
      '</svg>'
    );
  }

  function isYesValue(value) {
    return /^yes\b/i.test(clean(value));
  }

  function sleeveSvg(hasSleeve) {
    if (!hasSleeve) {
      return (
        '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<ellipse cx="50" cy="32" rx="24" ry="10" stroke-width="4"/>' +
          '<path d="M26 32V67C26 73 37 78 50 78C63 78 74 73 74 67V32" stroke-width="4"/>' +
          '<ellipse cx="50" cy="67" rx="24" ry="10" stroke-width="4"/>' +
          '<path d="M23 23L77 77" stroke="#9c2e24" stroke-width="7" stroke-linecap="round"/>' +
        '</svg>'
      );
    }

    return (
      '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<ellipse cx="50" cy="25" rx="25" ry="11" stroke-width="4"/>' +
        '<path d="M25 25V70C25 77 36 83 50 83C64 83 75 77 75 70V25" stroke-width="4"/>' +
        '<ellipse cx="50" cy="70" rx="25" ry="11" stroke-width="4"/>' +
        '<ellipse cx="50" cy="25" rx="12" ry="5" stroke-width="3"/>' +
      '</svg>'
    );
  }

  function visualMountingGrid(root,kind) {
    var grid=cardGrid(root,2,false);
    grid.classList.add(kind==='adapter' ? 'sparc-garage-adapter-mount' : 'sparc-garage-sleeve-cards');
    return grid;
  }

  var INFO_CONTENT = {
    finish: {
      eyebrow: "01 · Finish",
      title: "Grip Finish",
      copy: "Choose the finish for the Garage Series steering wheel grip and center assembly."
    },
    mounting: {
      eyebrow: "02 · Mounting",
      title: "Mounting & Fitment",
      copy: "Choose the 6-bolt steering-column adapter for your Garage Series steering wheel. No Adapter is a valid selection."
    },
    accessories: {
      eyebrow: "03 · Accessories",
      title: "Optional Accessories",
      copy: "Add compatible optional accessories to your Garage Series steering wheel package."
    },
    summary: {
      eyebrow: "Build Review",
      title: "Configuration Summary",
      copy: "Review the complete Garage Series configuration before adding it to your cart."
    }
  };

  function currentSectionImage(name) {
    var section = accs[name] && accs[name].section;
    if (!section) return "";

    var selected =
      q(".sparc-option-card.is-selected img", section) ||
      q(".sparc-option-card img", section);

    return selected ? (selected.currentSrc || selected.src || "") : "";
  }

  function currentSectionSelection(name) {
    var s = getState();

    if (name === "finish") {
      return friendly(s.finish);
    }

    if (name === "mounting") {
      return [
        s.adapter,
        (
          hubSleeveIsRequired(s) &&
          s.hubSleeve
        )
          ? "Sleeve " + s.hubSleeve
          : ""
      ]
        .filter(Boolean)
        .map(friendly)
        .join(" · ");
    }

    if (name === "accessories") {
      return valueEquals(s.careKit,"Yes")
        ? "Steering Wheel Care Kit"
        : "None";
    }

    return "";
  }

  function ensureInfoModal() {
    var existing = document.getElementById("sparc-info-modal");
    if (existing) return existing;

    var modal = el("dialog","");
    modal.id = "sparc-info-modal";
    modal.setAttribute("aria-hidden","true");

    var backdrop = el("div","sparc-info-modal__backdrop","");
    modal.appendChild(backdrop);

    var dialog = el("div","sparc-info-modal__dialog","");
    dialog.setAttribute("role","dialog");
    dialog.setAttribute("aria-modal","true");

    var head = el("div","sparc-info-modal__head","");
    var titleWrap = el("div","","");

    titleWrap.appendChild(
      el("span","sparc-info-modal__eyebrow","")
    );

    titleWrap.appendChild(
      el("h2","sparc-info-modal__title","")
    );

    var close = el("button","sparc-info-modal__close","×");
    close.type = "button";
    close.setAttribute("aria-label","Close information popup");

    head.appendChild(titleWrap);
    head.appendChild(close);
    dialog.appendChild(head);

    var body = el("div","sparc-info-modal__body","");
    var image = document.createElement("img");
    image.className = "sparc-info-modal__image";

    body.appendChild(image);

    body.appendChild(
      el("div","sparc-info-modal__thumbs","")
    );

    body.appendChild(
      el("div","sparc-info-modal__selection","")
    );
    body.appendChild(
      el("div","sparc-info-modal__copy","")
    );

    dialog.appendChild(body);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    function closeModal() {
      if (typeof modal.close==='function' && modal.open) modal.close();
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden","true");
      document.body.classList.remove("sparc-modal-open");
    }

    modal.addEventListener("cancel",function(e){e.preventDefault();closeModal();});
    close.addEventListener("click",closeModal);
    backdrop.addEventListener("click",closeModal);

    document.addEventListener("keydown",function(e){
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    return modal;
  }

  function openInfoModal(name) {
    var content = INFO_CONTENT[name];
    if (!content) return;

    var modal = ensureInfoModal();

    q(".sparc-info-modal__eyebrow",modal).textContent = content.eyebrow;
    q(".sparc-info-modal__title",modal).textContent = content.title;
    q(".sparc-info-modal__copy",modal).textContent = content.copy;

    var selection = q(".sparc-info-modal__selection",modal);
    var selectedText = currentSectionSelection(name);
    selection.textContent = selectedText
      ? "CURRENT SELECTION · " + selectedText
      : "NO SELECTION YET";

    var image = q(".sparc-info-modal__image",modal);
    var src = currentSectionImage(name);

    if (src) {
      image.src = src;
      image.alt = content.title;
      image.classList.add("has-image");
    } else {
      image.removeAttribute("src");
      image.classList.remove("has-image");
    }

    if (typeof modal.showModal==='function' && !modal.open) modal.showModal();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden","false");
    document.body.classList.add("sparc-modal-open");
  }

  function prepareGarageProductLayout() {
    var section = document.getElementById("ProductSection");
    if (!section) return;

    /* Activate only the product-local template rules. Because the class is
       on ProductSection instead of BODY, rules for .site-wrapper cannot fire. */
    section.classList.add("sparc-garage-template");

    /* The locked Muscle CSS was originally activated by a series-template
       wrapper that exists on Muscle product templates. Driver's older Supply
       product template does not have that wrapper, so create the equivalent
       runtime classes before any layout rules are applied. */
    var main=document.getElementById("MainContent");
    if (main) {
      main.classList.add("sparc-garage-main-content");
    }

    var meta =
      q(".product-single__meta", section) ||
      q(".product-single__meta");

    var optionsColumn = meta
      ? meta.closest(".grid__item")
      : null;

    if (meta) {
      meta.classList.add("sparc-garage-product-meta");
    }

    if (optionsColumn) {
      optionsColumn.classList.add("sparc-garage-options-column");
    }

    var photo =
      q(".product-single__featured-image-wrapper", section) ||
      q(".product-single__photos", section) ||
      q(".product-single__photo", section) ||
      q(".product-single__featured-image", section);

    var heroColumn = photo
      ? photo.closest(".grid__item")
      : null;

    if (heroColumn) {
      heroColumn.classList.add("sparc-garage-hero-column");
    }

    var stage =
      q(".product-single", section) ||
      q(".grid.product-single", section);

    /* Some Driver product pages use a slightly different Supply wrapper.
       If .product-single is not the common two-column stage, use the smallest
       common ancestor of the real hero and options columns. */
    if (
      (!stage || !stage.contains(optionsColumn) || !stage.contains(heroColumn)) &&
      optionsColumn &&
      heroColumn
    ) {
      stage=commonAncestor([
        optionsColumn,
        heroColumn
      ]);
    }

    if (stage) {
      stage.classList.add("sparc-garage-product-stage");
    }

    if (window.console && console.info) {
      console.info(
        "[SPARC GARAGE V1.7] Layout targets:",
        {
          stage:stage,
          heroColumn:heroColumn,
          optionsColumn:optionsColumn,
          meta:meta
        }
      );
    }
  }

  function ensureGarageMount() {
    if (!sourceHost || !sourceHost.parentNode) return null;

    var existing =
      document.getElementById("sparc-garage-configurator-mount");

    if (existing) return existing;

    var mount = el("div","sparc-garage-configurator-mount");
    mount.id = "sparc-garage-configurator-mount";

    var slot = el("div","sparc-garage-configurator-panel-slot");
    slot.id = "sparc-garage-configurator-panel-slot";

    mount.appendChild(slot);
    sourceHost.parentNode.insertBefore(mount, sourceHost);

    return mount;
  }

  function currentGarageProductTitle() {
    /*
      The Driver product template already renders Shopify's current product
      title in the page H1. Read that instead of hardcoding a wheel name so
      one configurator asset works for Truss, Triple Crown, and every other
      Garage Series product using the template.
    */
    var selectors = [
      '#ProductSection .product-single__title',
      '.product-single__title',
      '[itemprop="name"].product-single__title',
      'h1[itemprop="name"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var node = document.querySelector(selectors[i]);
      if (node) {
        var title = clean(node.textContent || '');
        if (title) return title;
      }
    }

    /* Last-resort fallback from document title; strip store suffix. */
    var docTitle = clean(document.title || '');
    if (docTitle) {
      var parts = docTitle.split(/\s+[–—|-]\s+/);
      if (parts[0]) return clean(parts[0]);
    }

    return 'Steering Wheel';
  }

  function buildPanel() {
    sourceHost=commonAncestor(
      CORE_REF_KEYS
        .map(function(k){ return refs[k]; })
        .filter(Boolean)
    );

    if(!sourceHost || !sourceHost.parentNode) return false;

    prepareGarageProductLayout();
    ensureGarageMount();

    panel=el("section","");
    panel.id="sparc-garage-configurator";

    var header=el("div","sparc-build-header");
    var row=el("div","sparc-build-header__row");
    var tw=el("div","");

    tw.appendChild(
      el(
        "h2",
        "sparc-build-title",
        "Build Your " + currentGarageProductTitle()
      )
    );

    tw.appendChild(
      el(
        "div",
        "sparc-build-subtitle",
        "Configure your steering wheel."
      )
    );

    row.appendChild(tw);

    var metrics=el("div","sparc-build-metrics");

    var pm=el("div","");
    pm.appendChild(
      el("span","sparc-metric-label","CONFIGURED PRICE")
    );
    var pv=el("strong","sparc-metric-value","—");
    pv.id="sparc-config-price";
    pm.appendChild(pv);

    var lm=el("div","sparc-lead-metric");
    lm.appendChild(
      el("span","sparc-metric-label","EST. PRODUCTION")
    );
    var lv=el("strong","sparc-metric-value","—");
    lv.id="sparc-config-lead";
    lm.appendChild(lv);

    metrics.appendChild(pm);
    metrics.appendChild(lm);
    row.appendChild(metrics);
    header.appendChild(row);
    panel.appendChild(header);

    var tr=el("nav","sparc-config-tabs");
    tr.appendChild(makeTab("finish","FINISH"));
    tr.appendChild(makeTab("mounting","MOUNTING"));
    tr.appendChild(makeTab("accessories","ACCESSORIES"));
    tr.appendChild(makeTab("summary","SUMMARY"));
    panel.appendChild(tr);

    var list=el("div","sparc-accordion-list");

    accs.finish=accordion(
      "finish",
      "01",
      "GRIP FINISH"
    );

    accs.finish.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose Machine Finish or Satin Black for the Garage Series steering wheel."
      )
    );

    accs.finishChoices=cardGrid(refs.finish,2,false);
    accs.finish.inner.appendChild(accs.finishChoices);

    list.appendChild(accs.finish.section);

    accs.mounting=accordion(
      "mounting",
      "02",
      "MOUNTING"
    );

    accs.mounting.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the 6-bolt steering-column adapter. No Adapter is a valid completed selection."
      )
    );

    var adapterGroup=el(
      "div",
      "sparc-mounting-group"
    );

    adapterGroup.appendChild(
      el("div","sparc-subhead","COLUMN ADAPTER")
    );

    accs.adapterChoices=visualMountingGrid(refs.adapter,"adapter");
    adapterGroup.appendChild(accs.adapterChoices);

    accs.mounting.inner.appendChild(
      adapterGroup
    );

    accs.hubSleeveBlock=conditional();

    var sleeveInner=q(
      ".sparc-conditional__inner",
      accs.hubSleeveBlock
    );

    var sleeveGroup=el(
      "div",
      "sparc-mounting-group"
    );

    sleeveGroup.appendChild(
      el("div","sparc-subhead","HUB SLEEVE")
    );

    accs.hubSleeveChoices=el(
      "div",
      "sparc-card-grid sparc-card-grid--2 sparc-garage-hub-sleeve-mount"
    );

    sleeveGroup.appendChild(
      accs.hubSleeveChoices
    );

    sleeveInner.appendChild(
      sleeveGroup
    );

    accs.mounting.inner.appendChild(
      accs.hubSleeveBlock
    );

    list.appendChild(
      accs.mounting.section
    );

    accs.accessories=accordion(
      "accessories",
      "03",
      "ACCESSORIES"
    );

    accs.accessories.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Add optional accessories to your Garage Series steering wheel package."
      )
    );

    var careGroup=el(
      "div",
      "sparc-accessory-group sparc-accessory-group--care"
    );

    careGroup.appendChild(
      el("div","sparc-subhead","CARE & MAINTENANCE")
    );

    accs.careKitChoices=el(
      "div",
      "sparc-care-kit-choice-mount"
    );

    careGroup.appendChild(
      accs.careKitChoices
    );

    accs.accessories.inner.appendChild(
      careGroup
    );

    list.appendChild(
      accs.accessories.section
    );

    bindLiveAccessoryClicks();

    accs.summary=accordion(
      "summary",
      "✓",
      "CONFIGURATION SUMMARY"
    );

    accs.summary.inner.appendChild(
      el(
        "p",
        "sparc-summary-intro",
        "Review every selected option, configured price, and mounting choice before adding your Garage Series steering wheel to the cart."
      )
    );

    var sum=el("div","sparc-summary");

    [
      ["finish","Grip Finish"],
      ["adapter","Adapter"],
      ["hubSleeve","Hub Sleeve"],
      ["careKit","Steering Wheel Care Kit"]
    ].forEach(function(pair){
      var sr=el("div","sparc-summary-row");

      sr.appendChild(
        el(
          "div",
          "sparc-summary__label",
          pair[1]
        )
      );

      sr.appendChild(
        el(
          "span",
          "sparc-summary__leader",
          ""
        )
      );

      var value=el(
        "div",
        "sparc-summary__value",
        "—"
      );

      value.dataset.summaryKey=
        pair[0];

      sr.appendChild(value);
      sum.appendChild(sr);
    });

    accs.summary.inner.appendChild(sum);
    list.appendChild(accs.summary.section);

    panel.appendChild(list);

    var slot=
      document.getElementById(
        "sparc-garage-configurator-panel-slot"
      );

    var mount=
      document.getElementById(
        "sparc-garage-configurator-mount"
      );

    if (slot) {
      slot.appendChild(panel);
    } else if (mount) {
      mount.insertBefore(
        panel,
        mount.firstChild
      );
    } else {
      sourceHost.parentNode.insertBefore(
        panel,
        sourceHost
      );
    }

    Object.keys(refs).forEach(function(k){
      if (
        refs[k] &&
        !panel.contains(refs[k])
      ) {
        refs[k].classList.add(
          "sparc-source-hidden"
        );
      }
    });

    ensureAccessoryUI();
    hideLegacyDecorations();
    openSection("finish");
    setTimeout(debugImageData,250);

    return true;
  }

  function refreshVisualCardImages(root, section) {
    if (!root || !section) return;

    var latest=choices(root);

    qa(
      ".sparc-option-card[data-value]",
      section
    ).forEach(function(card) {
      if (card.dataset.sourceId!==root.id) return;
      var value=card.dataset.value;

      var choice=latest.find(function(c) {
        return String(c.value)===String(value);
      });

      if (!choice) return;

      var detail=matchingOptionDetail(
        root.id,
        value
      );

      var imageUrl=selectorImageForOption(
        root,
        value,
        choice.image
      );

      var imageWrap=q(
        ".sparc-option-card__image",
        card
      );

      if (!imageWrap) return;

      var existingImg=q(
        "img",
        imageWrap
      );

      var placeholder=q(
        ".sparc-option-card__placeholder",
        imageWrap
      );

      if (imageUrl) {
        if (!existingImg) {
          existingImg=
            document.createElement("img");

          imageWrap.innerHTML="";
          imageWrap.appendChild(existingImg);
        }

        existingImg.alt=
          detail && detail.imageAltText
            ? detail.imageAltText
            : friendly(value);

        if (existingImg.getAttribute("src")!==imageUrl) {
          existingImg.src=imageUrl;
        }
      } else {
        if (existingImg) {
          imageWrap.innerHTML="";
          placeholder=null;
        }

        if (!placeholder) {
          placeholder=el(
            "div",
            "sparc-option-card__placeholder",
            "Add option image in Hulk Admin"
          );

          imageWrap.appendChild(
            placeholder
          );
        }
      }
    });
  }

  function syncChoiceClasses(root, section) {
    if (!root || !section) return;

    var value = current(root);

    qa("[data-source-id][data-value]", section).forEach(function(node) {
      if (node.dataset.sourceId !== root.id) return;

      node.classList.toggle(
        "is-selected",
        String(node.dataset.value) === String(value)
      );
    });
  }

  function setConditional(block, show) {
    if (!block) return;
    block.classList.toggle("is-visible", !!show);
  }
  function moveChildren(from,to) {
    while (from && from.firstChild) {
      to.appendChild(from.firstChild);
    }
  }

  function hideLegacyAccessoryLabels() {
    if (!panel) return;

    var form =
      panel.closest("form") ||
      document.querySelector("form[action*='/cart/add']") ||
      document;

    var matches=qa("*",form).filter(function(node){
      if (panel.contains(node)) return false;
      if (node.classList.contains("sparc-source-hidden")) return false;
      if (node.classList.contains("sparc-source-decoration-hidden")) return false;
      if (containsCoreRef(node)) return false;

      return clean(node.textContent).toLowerCase() ===
        "steering wheel care kit";
    });

    matches.sort(function(a,b){
      if (a.children.length !== b.children.length) {
        return a.children.length - b.children.length;
      }

      var ar=a.getBoundingClientRect();
      var br=b.getBoundingClientRect();
      return (ar.width*ar.height) - (br.width*br.height);
    });

    if (matches.length) {
      matches[0].classList.add("sparc-source-decoration-hidden");
    }
  }

  function safelyHideAccessorySource(root) {
    if (!root) return;
    if (!panel) return;
    if (root === sourceHost) return;
    if (root === panel || root.contains(panel)) return;
    if (containsCoreRef(root)) return;

    root.classList.add("sparc-source-hidden");
  }

  function accessoryKeyForSourceId(sourceId) {
    if (sourceId === IDS.careKit) return "careKit";
    return "";
  }

  function currentAccessoryRoot(key) {
    if (key === "careKit") {
      refs[key]=resolveAccessoryRef(key);
      return refs[key] || null;
    }

    refreshRefs();
    return refs[key] || null;
  }

  function bindLiveAccessoryClicks() {
    if (!accs.accessories || !accs.accessories.section) return;
    if (accs.accessories.section._sparcLiveAccessoryBound) return;

    accs.accessories.section._sparcLiveAccessoryBound=true;

    accs.accessories.section.addEventListener(
      "click",
      function(e){
        if (e.target.closest(".sparc-option-info")) return;

        var card=e.target.closest(
          ".sparc-option-card[data-source-id]"
        );

        if (!card || !accs.accessories.section.contains(card)) return;

        var key=
          card.dataset.accessoryKey ||
          accessoryKeyForSourceId(card.dataset.sourceId || "");

        if (key !== "careKit") return;

        var root=currentAccessoryRoot("careKit");
        if (!root) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        e.__sparcCareHandled=true;

        var nextValue=
          valueEquals(current(root),"Yes")
            ? "No"
            : "Yes";

        choose(root,nextValue);

        requestAnimationFrame(function(){
          var liveCare=currentAccessoryRoot("careKit");

          if (liveCare) {
            syncChoiceClasses(
              liveCare,
              accs.accessories.section
            );
          }
        });
      },
      true
    );
  }

  function ensureAccessoryUI() {
    var live=resolveAccessoryRef("careKit");

    if (live) {
      refs.careKit=live;

      if (panel && !panel.contains(live)) {
        safelyHideAccessorySource(live);
      }
    }

    if (accs.careKitChoices) {
      var careId=refs.careKit && refs.careKit.id || "";
      var renderedCareId=
        accs.careKitChoices.dataset.sourceId || "";

      if (
        refs.careKit &&
        (
          renderedCareId !== careId ||
          !accs.careKitChoices.children.length
        )
      ) {
        accs.careKitChoices.innerHTML="";
        accs.careKitChoices.dataset.sourceId=careId;

        moveChildren(
          optionalAccessoryToggleCard(
            refs.careKit,
            "Yes",
            "No",
            "STEERING WHEEL CARE KIT",
            "Add the SPARC steering wheel care kit to your order. Select the card again to remove it."
          ),
          accs.careKitChoices
        );
      }
    }

    hideLegacyAccessoryLabels();
  }

  function replaceMountChildren(mount,build,root) {
    if (!mount || !root) return;
    var values=sourceSelect(root)
      ? qa('option',sourceSelect(root)).map(function(n){return [n.value,n.textContent];})
      : sourceInputs(root).map(function(n){return [n.value,n.disabled];});
    var signature=JSON.stringify(values);
    if (mount._sparcRoot===root && mount._sparcSignature===signature && mount.children.length) return;
    mount.innerHTML='';
    mount.dataset.sourceId=root.id || '';
    mount._sparcRoot=root;
    mount._sparcSignature=signature;
    moveChildren(build(),mount);
  }







  function ensureGarageHubSleeveUI() {
    replaceMountChildren(accs.finishChoices,function(){return cardGrid(refs.finish,2,false);},refs.finish);
    replaceMountChildren(accs.adapterChoices,function(){return visualMountingGrid(refs.adapter,'adapter');},refs.adapter);
    replaceMountChildren(accs.hubSleeveChoices,function(){return visualMountingGrid(refs.hubSleeve,'sleeve');},refs.hubSleeve);
  }

  function hubSleeveApplies(s) { return sourceVisible(refs.hubSleeve); }

  function hubSleeveIsRequired(s) { return sourceVisible(refs.hubSleeve); }

  function syncMirror(field,root) { if(field&&field._mirror) field._mirror.value=current(root); }

  function sync() {
    syncPending=false;
    if(!panel)return;

    refreshRefs();
    hideLiveSourceRefs();
    ensureGarageHubSleeveUI();
    ensureAccessoryUI();

    var s=getState();

    syncChoiceClasses(
      refs.finish,
      accs.finish.section
    );

    syncChoiceClasses(
      refs.adapter,
      accs.mounting.section
    );

    syncChoiceClasses(
      refs.hubSleeve,
      accs.mounting.section
    );

    syncChoiceClasses(
      refs.careKit,
      accs.accessories.section
    );

    refreshVisualCardImages(
      refs.finish,
      accs.finish.section
    );

    if (refs.careKit) {
      refreshVisualCardImages(
        refs.careKit,
        accs.accessories.section
      );
    }

    var sleeveRequired=
      hubSleeveIsRequired(s);

    setConditional(
      accs.hubSleeveBlock,
      sleeveRequired &&
      !!refs.hubSleeve
    );

    refreshVisualCardImages(refs.adapter,accs.mounting.section);
    refreshVisualCardImages(refs.hubSleeve,accs.mounting.section);

    q(
      "#sparc-config-price",
      panel
    ).textContent=
      configuredPrice();

    q(
      "#sparc-config-lead",
      panel
    ).textContent=
      leadTime(s);

    if (leadDebugEnabled()) {
      setTimeout(renderLeadDebug,0);
    }

    q(
      ".sparc-accordion__summary",
      accs.finish.section
    ).textContent=
      friendly(s.finish);

    var ms=
      s.adapter
        ? friendly(s.adapter)
        : "Not selected";

    if (
      sleeveRequired &&
      s.hubSleeve
    ) {
      ms +=
        " · Sleeve " +
        friendly(
          s.hubSleeve
        );
    }

    q(
      ".sparc-accordion__summary",
      accs.mounting.section
    ).textContent=ms;

    q(
      ".sparc-accordion__summary",
      accs.accessories.section
    ).textContent=
      valueEquals(
        s.careKit,
        "Yes"
      )
        ? "Care Kit"
        : "None selected";

    qa(
      "[data-summary-key]",
      accs.summary.section
    ).forEach(function(n){
      var key=n.dataset.summaryKey;
      var v=s[key];

      if (
        key==="hubSleeve" &&
        !sleeveRequired
      ) {
        v="";
      }

      if (key==="careKit") {
        v=
          valueEquals(v,"Yes")
            ? "Included"
            : "";
      }

      n.textContent=
        v
          ? friendly(v)
          : "—";
    });

    if (
      sparcValidationAttempted
    ) {
      applyValidationState();
    }

    hideGarageLegacyGripFinishLabel();
    scheduleResize();
  }

  function queueSync(){
    if(syncPending)return;
    syncPending=true;
    requestAnimationFrame(sync);
  }

  function delayedSync() {
    queueSync();
    (delayedSync._timers || []).forEach(clearTimeout);
    delayedSync._timers=[140,420,900].map(function(delay) {
      return setTimeout(queueSync,delay);
    });
  }

  function alignGarageProductStage() {
    var stage=q(".sparc-garage-product-stage");
    if(!stage)return;

    if(window.innerWidth<=860){
      stage.style.width="";
      stage.style.maxWidth="";
      stage.style.marginLeft="";
      stage.style.marginRight="";
      return;
    }

    var parent=stage.parentElement;
    if(!parent)return;

    var viewportWidth=
      document.documentElement.clientWidth ||
      window.innerWidth;

    var stageWidth=Math.min(
      1450,
      Math.max(0,viewportWidth-32)
    );

    var desiredLeft=
      Math.max(
        16,
        (viewportWidth-stageWidth)/2
      );

    var parentRect=
      parent.getBoundingClientRect();

    stage.style.width=
      Math.round(stageWidth)+"px";

    stage.style.maxWidth=
      Math.round(stageWidth)+"px";

    stage.style.marginLeft=
      Math.round(desiredLeft-parentRect.left)+"px";

    stage.style.marginRight="0";
  }

  function scheduleResize() {
    clearTimeout(resizeTimer);

    resizeTimer=setTimeout(function(){
      alignGarageProductStage();

      var stage=q(".sparc-garage-product-stage");
      var options=q(".sparc-garage-options-column");
      var hero=q(".sparc-garage-hero-column");

      if(!stage)return;

      if(window.innerWidth<=860){
        stage.style.minHeight="";
        stage.style.height="";
        return;
      }

      var stageRect=stage.getBoundingClientRect();
      var required=800;

      [hero,options].forEach(function(node){
        if(!node)return;

        var rect=node.getBoundingClientRect();

        if(rect.width<=0 || rect.height<=0)return;

        var bottom=
          rect.bottom -
          stageRect.top +
          70;

        required=Math.max(required,bottom);
      });

      stage.style.minHeight=
        Math.ceil(required)+"px";
    },120);
  }



  function activateTrueGarageWidth() {
    if (!panel) return;

    document.body.classList.add("sparc-garage-v13-active");

    var main = document.getElementById("MainContent");

    if (main) {
      main.classList.add("sparc-garage-main-content");
    }
    if (!main || !main.parentElement) return;

    /* In this older Supply layout, sidebar and MainContent are siblings in the
       same .grid. Hide every sibling except MainContent only after the Muscle
       Hulk configurator has successfully initialized. */
    Array.prototype.forEach.call(main.parentElement.children, function(child) {
      if (child !== main) {
        child.classList.add("sparc-garage-v13-sidebar-hidden");
      }
    });
  }

  function hideSmallestExactText(root, regex, className) {
    if (!root || !panel) return;

    var panelTop = panel.getBoundingClientRect().top;
    var matches = qa("*", root).filter(function(node) {
      if (panel.contains(node)) return false;
      if (node.classList.contains("sparc-source-hidden")) return false;

      var text = clean(node.textContent);
      if (!regex.test(text)) return false;

      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return false;

      return true;
    });

    /* Prefer the smallest/most-specific matching element. */
    matches.sort(function(a, b) {
      var aText = clean(a.textContent).length;
      var bText = clean(b.textContent).length;
      if (aText !== bText) return aText - bText;
      return a.children.length - b.children.length;
    });

    if (matches.length) {
      matches[0].classList.add(className);
    }
  }

  function hideLegacyTopPriceAndLeadV13() {
    if (!panel) return;

    var meta =
      panel.closest(".sparc-garage-product-meta") ||
      panel.closest(".product-single__meta") ||
      panel.parentElement;

    if (!meta) return;

    hideSmallestExactText(
      meta,
      /^\$[\d,]+(?:\.\d{2})?$/,
      "sparc-v13-old-price"
    );

    hideSmallestExactText(
      meta,
      /^(?:Up to\s+\d+\s+week(?:s)?\s+lead\s+time|Ships\s+in\s+\d+\s*(?:-|–|to)\s*\d+\s*week(?:s)?)$/i,
      "sparc-v13-old-lead"
    );
  }

  function moveQuantityBelowConfigurator() {
    if (!panel) return;

    var mount =
      document.getElementById("sparc-garage-configurator-mount");

    var slot =
      document.getElementById("sparc-garage-configurator-panel-slot");

    var optionsColumn =
      q(".sparc-garage-options-column") ||
      panel.closest(".grid__item");

    var form =
      (mount && mount.closest("form")) ||
      panel.closest("form") ||
      (optionsColumn && q("form",optionsColumn)) ||
      q("form.product-form");

    var realInput =
      (form && q('input[name="quantity"]',form)) ||
      (optionsColumn && q('input[name="quantity"]',optionsColumn)) ||
      q('#Quantity',document) ||
      q('input[name="quantity"]',document);

    if (!realInput) return;

    /* Hide normal known Supply quantity wrappers. */
    qa(".product-single__quantity",document).forEach(function(block){
      if (
        block.contains(realInput) ||
        q('input[name="quantity"]',block)
      ) {
        block.classList.add("sparc-real-quantity-hidden");
      }
    });

    /* Older Driver templates use a different compact wrapper. Starting from
       the real quantity input, hide the smallest safe ancestor that visually
       represents only Quantity + its input. */
    var p=realInput.parentElement;

    for(var i=0;i<6 && p && p!==document.body;i++,p=p.parentElement){
      if (panel.contains(p)) break;

      var rect=p.getBoundingClientRect();
      var text=clean(p.textContent).toLowerCase();
      var qtyInputs=qa('input[name="quantity"], #Quantity',p);

      var compact =
        rect.width > 0 &&
        rect.height > 0 &&
        rect.height < 130 &&
        rect.width < 900;

      var looksLikeQuantity =
        text.indexOf("quantity") !== -1 &&
        qtyInputs.length === 1;

      if (compact && looksLikeQuantity) {
        p.classList.add("sparc-real-quantity-hidden");
        break;
      }
    }

    var host =
      mount ||
      (slot && slot.parentElement) ||
      panel.parentElement;

    if (!host) return;

    var mirror=q(".sparc-quantity-mirror",host);

    if (!mirror) {
      mirror=el("div","sparc-quantity-mirror");

      var label=el(
        "label",
        "sparc-quantity-mirror__label",
        "QUANTITY"
      );

      var input=document.createElement("input");
      input.type="number";
      input.min=realInput.min || "1";
      input.step=realInput.step || "1";
      input.value=realInput.value || "1";
      input.className="sparc-quantity-mirror__input";

      mirror.appendChild(label);
      mirror.appendChild(input);

      input.addEventListener("input",function(){
        realInput.value=input.value;
        realInput.dispatchEvent(
          new Event("input",{bubbles:true})
        );
        realInput.dispatchEvent(
          new Event("change",{bubbles:true})
        );
      });

      input.addEventListener("change",function(){
        realInput.value=input.value;
        realInput.dispatchEvent(
          new Event("change",{bubbles:true})
        );
      });

      realInput.addEventListener("change",function(){
        if(input.value!==realInput.value){
          input.value=realInput.value;
        }
      });
    }

    /* Dedicated mount order:
       panel-slot
       quantity mirror
       This cannot place Quantity above the panel. */
    if (mount && slot) {
      if (
        mirror.parentElement !== mount ||
        slot.nextSibling !== mirror
      ) {
        mount.insertBefore(mirror,slot.nextSibling);
      }
    } else {
      if (mirror.parentElement !== host) {
        host.appendChild(mirror);
      }

      if (panel.nextSibling !== mirror) {
        host.insertBefore(mirror,panel.nextSibling);
      }
    }

    var mirrorInput=q(
      ".sparc-quantity-mirror__input",
      mirror
    );

    if (
      mirrorInput &&
      mirrorInput.value !== realInput.value
    ) {
      mirrorInput.value=realInput.value || "1";
    }
  }

  function hideOldProductPriceAndLeadTime() {
    if (!panel) return;

    var meta = panel.closest(".sparc-garage-product-meta") || panel.parentElement;
    if (!meta) return;

    var panelTop = panel.getBoundingClientRect().top;

    /* Hide standalone price-only elements above the configurator.
       Do not touch anything inside the custom panel or Hulk's total source. */
    qa("*", meta).forEach(function(node) {
      if (panel.contains(node)) return;
      if (node.classList.contains("sparc-source-hidden")) return;

      var text = clean(node.textContent);
      if (!text) return;

      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return;

      if (
        node.children.length === 0 &&
        /^\$[\d,]+(?:\.\d{2})?$/.test(text)
      ) {
        node.classList.add("sparc-old-product-price-hidden");
      }

      if (
        node.children.length === 0 &&
        /^(?:(?:up to\s+)?\d+\s*(?:-|–|to)?\s*\d*\s*week(?:s)?(?:\s+lead\s+time)?|ships\s+in\s+\d+\s*(?:-|–|to)\s*\d+\s*week(?:s)?)$/i.test(text)
      ) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });

    /* Common legacy lead-time wording in this product template. */
    qa("p,div,span", meta).forEach(function(node) {
      if (panel.contains(node)) return;
      if (node.children.length > 1) return;

      var text = clean(node.textContent);
      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return;

      if (
        /^Up to \d+\s*week(?:s)? lead time$/i.test(text) ||
        /^Ships\s+in\s+\d+\s*(?:-|–|to)\s*\d+\s*week(?:s)?$/i.test(text)
      ) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });
  }

  function applyV11Polish() {
    activateTrueGarageWidth();
    alignGarageProductStage();
    moveQuantityBelowConfigurator();
    hideOldProductPriceAndLeadTime();
    hideLegacyTopPriceAndLeadV13();
    scheduleResize();
  }


  var sparcValidationAttempted = false;

  function hasUploadedCustomFile() {
    if (!accs.customLaserBlock) return false;

    /* If proxy has a file, require successful mirroring into Hulk's real field. */
    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    var source = findCustomLaserFileSource();
    var input =
      accs.customLaserBlock._sparcFileInput ||
      (source && source.input);

    return !!(
      input &&
      input.files &&
      input.files.length > 0
    );
  }

  function sectionValidity(s) {
    function complete(key) { return !sourceVisible(refs[key]) || !!s[key]; }
    return {finish:complete('finish'),mounting:complete('adapter') && complete('hubSleeve'),accessories:true};
  }

  function applyValidationState() {
    if (!panel) return true;

    var s = getState();
    var validity = sectionValidity(s);

    var firstInvalid = null;
    var anyInvalid = false;

    ["finish","mounting","accessories"].forEach(function(name) {
      var invalid = !validity[name];

      if (accs[name] && accs[name].section) {
        accs[name].section.classList.toggle("sparc-invalid", invalid);
      }

      if (invalid && !firstInvalid) firstInvalid = name;
      if (invalid) anyInvalid = true;
    });

    panel.classList.toggle("sparc-has-invalid", anyInvalid);

    return !anyInvalid;
  }

  function showValidationWarnings() {
    sparcValidationAttempted = true;

    panel.classList.add("sparc-validation-attempted");

    var valid = applyValidationState();

    if (!valid) {
      var s = getState();
      var validity = sectionValidity(s);
      var firstInvalid = ["finish","mounting","accessories"].find(function(name) {
        return !validity[name];
      });

      if (firstInvalid) {
        openSection(firstInvalid);

        setTimeout(function() {
          if (accs[firstInvalid] && accs[firstInvalid].section) {
            accs[firstInvalid].section.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }, 80);
      }
    }

    return valid;
  }

  function isAddToCartControl(node) {
    if (!node) return false;

    var control = node.closest(
      'button,input[type="submit"],a'
    );

    if (!control) return false;

    var text = clean(
      (control.textContent || "") + " " +
      (control.value || "") + " " +
      (control.getAttribute("aria-label") || "")
    ).toLowerCase();

    return /add\s+to\s+cart/.test(text);
  }

  function installRequiredValidation() {
    if (!panel) return;

    /* Inline warning at top of accordion list; hidden until first failed
       Add-to-Cart attempt. */
    var list = q(".sparc-accordion-list", panel);

    if (list && !q(".sparc-validation-message", panel)) {
      var msg = el(
        "div",
        "sparc-validation-message",
        "Please complete the required configuration options highlighted below before adding this steering wheel to your cart."
      );

      list.insertBefore(msg, list.firstChild);
    }

    document.addEventListener(
      "click",
      function(e) {
        if (!isAddToCartControl(e.target)) return;

        /* Restrict to this product's option/form area. */
        var control = e.target.closest('button,input[type="submit"],a');
        var productArea =
          q(".sparc-garage-options-column", document) ||
          q("#ProductSection", document);

        if (productArea && !productArea.contains(control)) return;

        if (!showValidationWarnings()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    var form =
      document.getElementById("sparc-garage-configurator-mount") &&
      document.getElementById("sparc-garage-configurator-mount").closest("form");

    if (form) {
      form.addEventListener(
        "submit",
        function(e) {
          if (!showValidationWarnings()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        },
        true
      );
    }
  }

  function accessoryDebugEnabled() {
    try {
      return new URLSearchParams(window.location.search)
        .get("sparc_accessory_debug") === "1";
    } catch(e) {
      return false;
    }
  }

  function logAccessoryDebug(label) {
    if (!accessoryDebugEnabled()) return;

    var care=resolveAccessoryRef("careKit");

    console.info("[SPARC GARAGE V1 ACCESSORIES] "+label,{
      careValue:current(care),
      careRoot:care
    });
  }

  function ensureRuntimeBreadcrumbStyle() {
    if (document.getElementById("sparc-garage-runtime-breadcrumb-style")) {
      return;
    }

    var style=document.createElement("style");
    style.id="sparc-garage-runtime-breadcrumb-style";
    style.textContent =
      "#sparc-garage-runtime-breadcrumb-wrap{" +
      "display:block!important;" +
      "box-sizing:border-box!important;" +
      "width:100%!important;" +
      "height:auto!important;" +
      "min-height:28px!important;" +
      "margin:0 0 18px!important;" +
      "padding:0!important;" +
      "overflow:visible!important;" +
      "}" +
      "#sparc-garage-runtime-breadcrumb{" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "gap:7px!important;" +
      "height:auto!important;" +
      "min-height:22px!important;" +
      "margin:0!important;" +
      "padding:3px 0 4px!important;" +
      "line-height:17px!important;" +
      "overflow:visible!important;" +
      "font:inherit!important;" +
      "font-size:11px!important;" +
      "white-space:nowrap!important;" +
      "}" +
      "#sparc-garage-runtime-breadcrumb a," +
      "#sparc-garage-runtime-breadcrumb span{" +
      "display:inline-block!important;" +
      "position:static!important;" +
      "height:auto!important;" +
      "min-height:17px!important;" +
      "margin:0!important;" +
      "padding:1px 0!important;" +
      "line-height:17px!important;" +
      "overflow:visible!important;" +
      "vertical-align:middle!important;" +
      "text-decoration:none;" +
      "}" +
      "#sparc-garage-runtime-breadcrumb .sparc-garage-runtime-breadcrumb__sep{" +
      "opacity:.7;" +
      "}";

    document.head.appendChild(style);
  }

  function findLegacyGarageBreadcrumbs(productTitle) {
    var titleNorm=clean(productTitle).toLowerCase();

    return qa("*",document).filter(function(node){
      if (!node || node===document.body || node===document.documentElement) {
        return false;
      }

      var rect=node.getBoundingClientRect();
      var text=clean(node.textContent).toLowerCase();

      if (
        rect.top < 50 ||
        rect.top > 280 ||
        rect.left < 40 ||
        rect.left > 650 ||
        rect.width <= 0 ||
        rect.width > 760 ||
        rect.height <= 0 ||
        rect.height > 90
      ) {
        return false;
      }

      var hasHome=text.indexOf("home") !== -1;
      var hasSeries=text.indexOf("garage series") !== -1;
      var hasTitle=titleNorm && text.indexOf(titleNorm) !== -1;

      return (
        (hasHome && hasSeries) ||
        (hasSeries && hasTitle)
      );
    });
  }

  function normalizeRenderedBreadcrumbText(value) {
    return String(value || "")
      .replace(/[›>»\/|·•]/g," ")
      .replace(/[^a-zA-Z0-9]+/g," ")
      .replace(/\s+/g," ")
      .trim()
      .toLowerCase();
  }

  function hideRenderedLegacyBreadcrumb(runtimeWrap, productTitle) {
    if (!runtimeWrap) return;

    var runtimeRect = runtimeWrap.getBoundingClientRect();

    var target = normalizeRenderedBreadcrumbText(
      "Home Garage Series " + productTitle
    );

    if (!target) return;

    var exact = [];
    var fallback = [];

    qa("*",document.body).forEach(function(node){
      if (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      ) {
        return;
      }

      var rect = node.getBoundingClientRect();

      /* Only inspect the visual breadcrumb zone ABOVE the clean runtime
         breadcrumb. This guarantees we cannot hide the replacement itself
         or anything down in the product area. */
      if (
        rect.width <= 0 ||
        rect.height <= 0 ||
        rect.left < 0 ||
        rect.left > 700 ||
        rect.top < 0 ||
        rect.top >= runtimeRect.top - 2 ||
        rect.width > 850 ||
        rect.height > 100
      ) {
        return;
      }

      /* innerText reflects the text the customer can actually see, unlike
         textContent which can include hidden/theme helper content. */
      var visible = "";
      try {
        visible = node.innerText || "";
      } catch(e) {
        visible = node.textContent || "";
      }

      var norm = normalizeRenderedBreadcrumbText(visible);
      if (!norm) return;

      var record = {
        node: node,
        rect: rect,
        norm: norm,
        area: rect.width * rect.height
      };

      if (norm === target) {
        exact.push(record);
        return;
      }

      /* Conservative fallback for themes that add a tiny hidden/pseudo word
         to the rendered line. */
      if (
        norm.indexOf("home") !== -1 &&
        norm.indexOf("garage series") !== -1 &&
        norm.indexOf(
          normalizeRenderedBreadcrumbText(productTitle)
        ) !== -1 &&
        norm.length <= target.length + 24
      ) {
        fallback.push(record);
      }
    });

    var matches = exact.length ? exact : fallback;
    if (!matches.length) return;

    /* The smallest compact node containing the whole visible breadcrumb is
       the actual legacy line/list rather than a larger layout wrapper. */
    matches.sort(function(a,b){
      if (a.area !== b.area) return a.area - b.area;

      return b.rect.top - a.rect.top;
    });

    var legacy = matches[0].node;

    legacy.style.setProperty(
      "display",
      "none",
      "important"
    );

    legacy.setAttribute(
      "data-sparc-legacy-breadcrumb-hidden",
      "true"
    );
  }

  function hideLegacyBreadcrumbByLinks(runtimeWrap, productTitle) {
    if (!runtimeWrap) return;

    var runtimeRect = runtimeWrap.getBoundingClientRect();
    var titleNorm = clean(productTitle).toLowerCase();

    function visible(node) {
      if (!node) return false;
      var r = node.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function isRuntime(node) {
      return (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      );
    }

    /* 1) Remove every visible legacy line that contains a Home link plus
          a Garage Series link. This is the clipped line visible in the
          screenshots. */
    qa("a",document).forEach(function(home){
      if (isRuntime(home)) return;
      if (clean(home.textContent).toLowerCase() !== "home") return;
      if (!visible(home)) return;

      var hr = home.getBoundingClientRect();

      /* Breadcrumbs are in the upper-left and above/near our replacement. */
      if (
        hr.left > 700 ||
        hr.top < 0 ||
        hr.top > runtimeRect.bottom + 25
      ) {
        return;
      }

      var p = home.parentElement;
      var line = null;

      for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
        if (isRuntime(p)) break;

        var links = qa("a",p);

        var hasHome = links.some(function(a){
          return clean(a.textContent).toLowerCase() === "home";
        });

        var hasSeries = links.some(function(a){
          return clean(a.textContent)
            .toLowerCase()
            .indexOf("garage series") !== -1;
        });

        if (hasHome && hasSeries) {
          line = p;
          break;
        }
      }

      if (line && !isRuntime(line)) {
        line.style.setProperty(
          "display",
          "none",
          "important"
        );
        line.setAttribute(
          "data-sparc-legacy-breadcrumb-hidden",
          "home-series"
        );
      } else {
        /* Fail-safe: at minimum the old Home anchor itself cannot remain
           visible if Supply's markup prevents identifying its line root. */
        home.style.setProperty(
          "display",
          "none",
          "important"
        );
      }
    });

    /* 2) Remove a separate legacy Garage Series > Product fragment if this
          Supply template renders one independently. Only linked Series text
          is considered, so the GARAGE SERIES product eyebrow is untouched. */
    qa("a",document).forEach(function(series){
      if (isRuntime(series)) return;

      var st = clean(series.textContent).toLowerCase();

      if (st.indexOf("garage series") === -1) return;
      if (!visible(series)) return;

      var sr = series.getBoundingClientRect();

      if (
        sr.left > 700 ||
        sr.top < 0 ||
        sr.top > runtimeRect.bottom + 35
      ) {
        return;
      }

      var p = series.parentElement;
      var fragment = null;

      for (var i=0; i<6 && p && p!==document.body; i++,p=p.parentElement) {
        if (isRuntime(p)) break;

        var text = clean(p.textContent).toLowerCase();
        var rect = p.getBoundingClientRect();

        var hasProduct =
          titleNorm &&
          text.indexOf(titleNorm) !== -1;

        var hasHome =
          text.indexOf("home") !== -1;

        if (
          hasProduct &&
          !hasHome &&
          rect.width > 0 &&
          rect.width < 700 &&
          rect.height > 0 &&
          rect.height < 80
        ) {
          fragment = p;
          break;
        }
      }

      if (fragment && !isRuntime(fragment)) {
        fragment.style.setProperty(
          "display",
          "none",
          "important"
        );
        fragment.setAttribute(
          "data-sparc-legacy-breadcrumb-hidden",
          "series-product"
        );
      }
    });
  }

  function cleanupGarageBreadcrumbDuplicates(
    runtimeWrap,
    productTitle
  ) {
    if (!runtimeWrap) return;

    var titleNorm=
      normalizeRenderedBreadcrumbText(
        productTitle
      );

    var target=
      normalizeRenderedBreadcrumbText(
        "Home Garage Series " +
        productTitle
      );

    function isRuntime(node) {
      return (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      );
    }

    /*
      Driver's older Supply template can place the legacy breadcrumb
      either ABOVE or BELOW the clean runtime breadcrumb.

      Do not depend on relative ordering. Inspect only the compact
      upper-left breadcrumb zone and hide every matching legacy line
      outside the runtime replacement.
    */
    qa("*",document.body).forEach(
      function(node) {
        if (!node || isRuntime(node)) {
          return;
        }

        var rect=
          node.getBoundingClientRect();

        if (
          rect.width <= 0 ||
          rect.height <= 0 ||
          rect.top < 0 ||
          rect.top > 330 ||
          rect.left < 0 ||
          rect.left > 720 ||
          rect.width > 900 ||
          rect.height > 100
        ) {
          return;
        }

        var visible="";

        try {
          visible=
            node.innerText || "";
        } catch(e) {
          visible=
            node.textContent || "";
        }

        var norm=
          normalizeRenderedBreadcrumbText(
            visible
          );

        if (!norm) return;

        var hasHome=
          norm.indexOf("home") !== -1;

        var hasSeries=
          norm.indexOf(
            "garage series"
          ) !== -1;

        var hasTitle=
          !!titleNorm &&
          norm.indexOf(
            titleNorm
          ) !== -1;

        var exact=
          norm === target;

        var compactMatch=
          hasHome &&
          hasSeries &&
          hasTitle &&
          norm.length <=
            target.length + 30;

        if (
          exact ||
          compactMatch
        ) {
          /*
            Never hide a large structural parent.
            The size constraints above keep this to the breadcrumb line,
            list, nav, or compact wrapper.
          */
          node.style.setProperty(
            "display",
            "none",
            "important"
          );

          node.setAttribute(
            "data-sparc-garage-legacy-breadcrumb-hidden",
            "true"
          );
        }
      }
    );

    /*
      Link-based fallback for unusual Supply markup.
      Unlike the previous version, this does NOT care whether
      the old line sits above or below the runtime breadcrumb.
    */
    qa("a",document).forEach(
      function(home) {
        if (isRuntime(home)) return;

        if (
          clean(home.textContent)
            .toLowerCase() !==
          "home"
        ) {
          return;
        }

        var hr=
          home.getBoundingClientRect();

        if (
          hr.width <= 0 ||
          hr.height <= 0 ||
          hr.top < 0 ||
          hr.top > 330 ||
          hr.left > 720
        ) {
          return;
        }

        var p=
          home.parentElement;

        for (
          var i=0;
          i<8 &&
          p &&
          p!==document.body;
          i++,
          p=p.parentElement
        ) {
          if (isRuntime(p)) break;

          var rect=
            p.getBoundingClientRect();

          if (
            rect.width <= 0 ||
            rect.height <= 0 ||
            rect.width > 900 ||
            rect.height > 100
          ) {
            continue;
          }

          var text=
            normalizeRenderedBreadcrumbText(
              p.innerText ||
              p.textContent
            );

          if (
            text.indexOf("home") !== -1 &&
            text.indexOf(
              "garage series"
            ) !== -1 &&
            (
              !titleNorm ||
              text.indexOf(
                titleNorm
              ) !== -1
            )
          ) {
            p.style.setProperty(
              "display",
              "none",
              "important"
            );

            p.setAttribute(
              "data-sparc-garage-legacy-breadcrumb-hidden",
              "link-fallback"
            );

            break;
          }
        }
      }
    );
  }

  function replaceGarageBreadcrumb() {
    ensureRuntimeBreadcrumbStyle();

    if (document.getElementById("sparc-garage-runtime-breadcrumb-wrap")) {
      return;
    }

    var productTitle =
      currentGarageProductTitle &&
      typeof currentGarageProductTitle === "function"
        ? currentGarageProductTitle()
        : "";

    if (!productTitle) {
      var title =
        q(".product-single__title") ||
        q("#ProductSection .product-single__title");
      productTitle=title ? clean(title.textContent) : "";
    }

    var homeLinks = qa("a",document).filter(function(a){
      return clean(a.textContent).toLowerCase() === "home";
    });

    var homeLink = null;
    var seriesLink = null;
    var originalBreadcrumb = null;

    homeLinks.some(function(home){
      /* Never use our own runtime breadcrumb as the source. */
      if (home.closest("#sparc-garage-runtime-breadcrumb-wrap")) {
        return false;
      }

      var p = home.parentElement;

      for (var i=0; i<6 && p && p!==document.body; i++,p=p.parentElement) {
        var text = clean(p.textContent);
        var rect = p.getBoundingClientRect();

        var hasHome =
          text.toLowerCase().indexOf("home") === 0;

        var hasSeries =
          text.toLowerCase().indexOf("garage series") !== -1;

        var compact =
          rect.top >= 0 &&
          rect.top < 280 &&
          rect.left < 700 &&
          rect.width > 0 &&
          rect.width < 800 &&
          rect.height > 0 &&
          rect.height < 90 &&
          text.length < 200;

        if (hasHome && hasSeries && compact) {
          homeLink = home;
          originalBreadcrumb = p;

          seriesLink = qa("a",p).find(function(a){
            return clean(a.textContent)
              .toLowerCase()
              .indexOf("garage series") !== -1;
          }) || null;

          return true;
        }
      }

      return false;
    });

    var productSection =
      document.getElementById("ProductSection") ||
      q(".product-single") ||
      q("main");

    if (!productSection) return;

    var insertionTarget=productSection;

    var parent=productSection.parentElement;
    while (
      parent &&
      parent!==document.body &&
      parent.children.length===1 &&
      parent.getBoundingClientRect().width < 1200
    ) {
      insertionTarget=parent;
      parent=parent.parentElement;
    }

    var wrap=el(
      "div",
      "sparc-garage-runtime-breadcrumb-wrap"
    );
    wrap.id="sparc-garage-runtime-breadcrumb-wrap";

    var crumb=el(
      "nav",
      "sparc-garage-runtime-breadcrumb"
    );
    crumb.id="sparc-garage-runtime-breadcrumb";
    crumb.setAttribute(
      "aria-label",
      "Breadcrumb"
    );

    function addLink(source,fallbackText,fallbackHref) {
      var href =
        source && source.getAttribute("href")
          ? source.getAttribute("href")
          : fallbackHref;

      if (href) {
        var a=document.createElement("a");
        a.href=href;
        a.textContent=
          source && clean(source.textContent)
            ? clean(source.textContent)
            : fallbackText;
        crumb.appendChild(a);
      } else {
        crumb.appendChild(
          el("span","",fallbackText)
        );
      }
    }

    function sep() {
      crumb.appendChild(
        el(
          "span",
          "sparc-garage-runtime-breadcrumb__sep",
          "›"
        )
      );
    }

    addLink(homeLink,"Home","/");
    sep();
    addLink(
      seriesLink,
      "Garage Series",
      "/collections/garage-series"
    );

    if (productTitle) {
      sep();

      var current=el(
        "span",
        "sparc-garage-runtime-breadcrumb__current",
        productTitle
      );

      current.setAttribute(
        "aria-current",
        "page"
      );

      crumb.appendChild(current);
    }

    wrap.appendChild(crumb);

    insertionTarget.parentNode.insertBefore(
      wrap,
      insertionTarget
    );

    /* THE IMPORTANT V41.17 FIX:
       hide the exact compact legacy breadcrumb node that supplied the
       original Home link. This avoids depending on broad text matching. */
    if (
      originalBreadcrumb &&
      !originalBreadcrumb.contains(wrap)
    ) {
      originalBreadcrumb.style.setProperty(
        "display",
        "none",
        "important"
      );
    }

    /* Also hide any remaining compact legacy breadcrumb fragments nearby,
       but never touch the new runtime breadcrumb. */
    function cleanupLegacyFragments() {
      var titleNorm=
        clean(productTitle).toLowerCase();

      qa("*",document).forEach(function(node){
        if (
          node===wrap ||
          node===crumb ||
          wrap.contains(node) ||
          node.contains(wrap)
        ) {
          return;
        }

        var rect=node.getBoundingClientRect();

        if (
          rect.top < 0 ||
          rect.top > 280 ||
          rect.left < 20 ||
          rect.left > 700 ||
          rect.width <= 0 ||
          rect.width > 800 ||
          rect.height <= 0 ||
          rect.height > 90
        ) {
          return;
        }

        var text=
          clean(node.textContent).toLowerCase();

        var hasHome=
          text.indexOf("home") !== -1;

        var hasSeries=
          text.indexOf("garage series") !== -1;

        var hasTitle=
          titleNorm &&
          text.indexOf(titleNorm) !== -1;

        if (
          (hasHome && hasSeries) ||
          (hasSeries && hasTitle)
        ) {
          /* Hide only compact text-level containers. */
          if (qa("img",node).length) return;
          if (qa("#ProductSection",node).length) return;

          node.style.setProperty(
            "display",
            "none",
            "important"
          );
        }
      });
    }

    cleanupLegacyFragments();

    hideRenderedLegacyBreadcrumb(
      wrap,
      productTitle
    );

    hideLegacyBreadcrumbByLinks(
      wrap,
      productTitle
    );

    cleanupGarageBreadcrumbDuplicates(
      wrap,
      productTitle
    );

    [80,220,500,1000].forEach(function(delay){
      setTimeout(function(){
        cleanupLegacyFragments();

        hideRenderedLegacyBreadcrumb(
          wrap,
          productTitle
        );

        hideLegacyBreadcrumbByLinks(
          wrap,
          productTitle
        );

        cleanupGarageBreadcrumbDuplicates(
          wrap,
          productTitle
        );
      },delay);
    });
  }


  function isDirectProductPath() {
    return (
      String(
        window.location.pathname || ""
      ).toLowerCase().indexOf(
        "/products/"
      ) !== -1
    );
  }

  function isGarageProductPage() {
    var path=
      String(
        window.location.pathname || ""
      ).toLowerCase();

    if (
      path.indexOf(
        "/collections/garage-series/"
      ) !== -1
    ) {
      return true;
    }

    /*
      Direct Shopify product/cart URLs do not preserve collection context.
      The Garage Finish selector is unique to Garage.
    */
    return !!document.getElementById(
      "sparc-garage-finish"
    );
  }

  function start() {
    if (!isGarageProductPage()) {
      if (
        isDirectProductPath() &&
        (start._directUrlRetries || 0) < 20
      ) {
        start._directUrlRetries=
          (start._directUrlRetries || 0) + 1;

        setTimeout(
          start,
          500
        );
      }

      return;
    }

    start._directUrlRetries=0;

    if(
      document.getElementById(
        "sparc-garage-configurator"
      )
    ) return;

    var missing=allRefsPresent();

    if(missing.length){
      if (
        !start._lastMissingLog ||
        Date.now() - start._lastMissingLog > 3000
      ) {
        console.info(
          "[SPARC GARAGE V1.7] Waiting for Hulk core selectors:",
          missing
        );

        start._lastMissingLog=
          Date.now();
      }

      setTimeout(start,500);
      return;
    }

    prepareGarageProductLayout();

    if(!buildPanel()){
      setTimeout(start,500);
      return;
    }

    refreshRefs();
    hideLiveSourceRefs();
    ensureGarageHubSleeveUI();
    ensureAccessoryUI();

    setTimeout(delayedSync,120);

    applyV11Polish();

    replaceGarageBreadcrumb();
    setTimeout(
      replaceGarageBreadcrumb,
      120
    );

    installRequiredValidation();

    var observer=
      new MutationObserver(
        function(records){
          if (!records.some(function(record) {
            return !(panel && (record.target===panel || panel.contains(record.target)));
          })) return;
          refreshRefs();
          delayedSync();
          setTimeout(
            applyV11Polish,
            80
          );
        }
      );

    observer.observe(
      sourceHost,
      {
        subtree:true,
        childList:true
      }
    );

    sourceHost.addEventListener(
      "change",
      delayedSync,
      true
    );

    sourceHost.addEventListener(
      "input",
      delayedSync,
      true
    );

    window.addEventListener(
      "resize",
      scheduleResize
    );

    delayedSync();
    scheduleResize();

    setTimeout(
      applyV11Polish,
      150
    );

    setTimeout(
      applyV11Polish,
      600
    );

    console.info(
      "[SPARC GARAGE HULK V2] Garage configurator initialized."
    );
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
  else start();
})();
